// import { useState, useEffect } from 'react';
// import { useNavigate, Link } from 'react-router-dom';
// import { useCart } from '../contexts/CartContext';
// import { useAuth } from '../contexts/AuthContext';
// import { paymentAPI, deliveryAPI, couponAPI, userAPI, addressAPI } from '../services/api';
// import { PriceRow, EmptyState, Spinner } from '../components/shared/index';
// import { format } from 'date-fns';
// import toast from 'react-hot-toast';

// export default function CartPage() {
//   const { cart, removeFromCart, updateCartItem, clearCart } = useCart();
//   const { user } = useAuth();
//   const navigate  = useNavigate();

//   const [step,       setStep]       = useState('cart');
//   const [address,    setAddress]    = useState({
//     name: user?.name || '', street: '', city: '', state: '', pincode: '', phone: user?.phone || ''
//   });
//   const [payMethod,  setPayMethod]  = useState('upi');
//   const [codEnabled, setCodEnabled] = useState(false);
//   const [processing,    setProcessing]    = useState(false);
//   const [summaryOpen,   setSummaryOpen]    = useState(false);
//   const [couponCode,    setCouponCode]    = useState('');
//   const [showSavePrompt, setShowSavePrompt] = useState(false);
//   const [couponInput,   setCouponInput]   = useState('');
//   const [couponData,    setCouponData]    = useState(null);  // { discount, message, coupon }
//   const [couponLoading, setCouponLoading] = useState(false);
//   const [couponError,   setCouponError]   = useState('');
//   const [deliveryInfo,  setDeliveryInfo]   = useState({ charge: 0, label: 'Delivery', freeAbove: null });

//   const isEmailVerified   = user?.isEmailVerified;
//   const isCollegeVerified = user?.isCollegeVerified;
//   const collegeActive     = isCollegeVerified && user?.collegeExpiresAt && new Date(user.collegeExpiresAt) > new Date();
//   const trustPoints       = user?.trustPoints || 0;
//   // Trust level order limits (mirrors backend LEVELS)
//   const TRUST_LIMITS = [
//     { name: 'New',     min: 0,    max: 99,        limit: 399 },
//     { name: 'Trusted', min: 100,  max: 299,        limit: 999 },
//     { name: 'Silver',  min: 300,  max: 599,        limit: 2499 },
//     { name: 'Gold',    min: 600,  max: 999,        limit: 4999 },
//     { name: 'Elite',   min: 1000, max: Infinity,   limit: Infinity },
//   ];
//   const trustLevel    = TRUST_LIMITS.find(l => trustPoints >= l.min && trustPoints <= l.max) || TRUST_LIMITS[0];
//   const orderLimit    = collegeActive ? Infinity : trustLevel.limit;
//   const cartTotal     = cart.items?.reduce((s, i) => s + (i.rentalPrice || i.price || 0) * (i.quantity || 1), 0) || 0;
//   const overLimit     = orderLimit !== Infinity && cartTotal > orderLimit;
//   const nextLevel     = overLimit ? TRUST_LIMITS[TRUST_LIMITS.indexOf(trustLevel) + 1] : null;
//   const canCheckout   = isEmailVerified && !overLimit;

//   // Fetch delivery charge when address changes
//   useEffect(() => {
//     const { pincode, city } = address;
//     if (!pincode && !city) return;
//     deliveryAPI.getCharge({ pincode, city })
//       .then(({ data }) => setDeliveryInfo({ charge: data.charge || 0, label: data.label || 'Delivery', freeAbove: data.freeAbove }))
//       .catch(() => {});
//   }, [address.pincode, address.city]);

//   useEffect(() => {
//     paymentAPI.getCodSettings()
//       .then(({ data }) => setCodEnabled(data.codEnabled))
//       .catch(() => {});
//   }, []);

//   const validateAddress = () => {
//     if (!address.name || !address.street || !address.city || !address.pincode || !address.phone) {
//       toast.error('Please fill all address fields.'); return false;
//     }
//     if (!/^[6-9]\d{9}$/.test(address.phone)) {
//       toast.error('Please enter a valid 10-digit phone number.'); return false;
//     }
//     if (!/^\d{6}$/.test(address.pincode)) {
//       toast.error('Please enter a valid 6-digit pincode.'); return false;
//     }
//     return true;
//   };

//   // Load Razorpay script dynamically (only once)
//   const loadRazorpay = () => {
//     return new Promise((resolve) => {
//       if (window.Razorpay) { resolve(true); return; }
//       const script = document.createElement('script');
//       script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//       script.onload  = () => resolve(true);
//       script.onerror = () => resolve(false);
//       document.body.appendChild(script);
//     });
//   };

//   const handleRazorpayCheckout = async () => {
//     if (!validateAddress()) return;
//     setProcessing(true);

//     try {
//       // Load Razorpay SDK
//       const loaded = await loadRazorpay();
//       if (!loaded) {
//         toast.error('Could not load payment gateway. Check your internet connection.');
//         setProcessing(false);
//         return;
//       }

//       // Step 1: Create Razorpay order on backend
//       const { data } = await paymentAPI.createRazorpayOrder({ shippingAddress: address, couponCode: couponCode || undefined });

//       // Step 2: Open Razorpay modal
//       const options = {
//         key:         data.keyId,
//         amount:      data.amount,          // paise
//         currency:    data.currency,
//         name:        'Warbadobe Rentals',
//         description: 'Luxury Fashion Rental',
//         image:       '/logo192.png',
//         order_id:    data.orderId,
//         prefill: {
//           name:    data.userName  || user?.name  || '',
//           email:   data.userEmail || user?.email || '',
//           contact: data.userPhone || (user?.phone ? `+91${user.phone}` : ''),
//         },
//         theme: { color: '#b8924a' },

//         handler: async (response) => {
//           // Step 3: Verify payment + create DB order
//           try {
//             const verifyRes = await paymentAPI.verifyRazorpayPayment({
//               razorpayOrderId:   response.razorpay_order_id,
//               razorpayPaymentId: response.razorpay_payment_id,
//               razorpaySignature: response.razorpay_signature,
//               shippingAddress:   address
//             });
//             clearCart();
//             toast.success(`🎉 Order ${verifyRes.data.order.orderId} placed successfully!`);
//             navigate('/orders');
//           } catch (verifyErr) {
//             toast.error(verifyErr.response?.data?.message || 'Payment verification failed. Please contact support.');
//           } finally {
//             setProcessing(false);
//           }
//         },

//         modal: {
//           ondismiss: () => {
//             toast('Payment cancelled.', { icon: 'ℹ️' });
//             setProcessing(false);
//           }
//         }
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.on('payment.failed', (response) => {
//         toast.error(`Payment failed: ${response.error.description || 'Please try again.'}`);
//         setProcessing(false);
//       });
//       rzp.open();

//     } catch (e) {
//       toast.error(e.response?.data?.message || 'Could not start payment. Please try again.');
//       setProcessing(false);
//     }
//   };

//   const handleCodCheckout = async () => {
//     if (!validateAddress()) return;
//     setProcessing(true);
//     try {
//       const { data } = await paymentAPI.placeCodOrder({ shippingAddress: address, couponCode: couponCode || undefined });
//       clearCart();
//       toast.success(`Order ${data.order.orderId} placed! 🎉 Pay ₹${data.order.grandTotal?.toLocaleString('en-IN')} on delivery.`);
//       navigate('/orders');
//     } catch (e) {
//       toast.error(e.response?.data?.message || 'Could not place order. Please try again.');
//       setProcessing(false);
//     }
//   };

//   const applyCoupon = async () => {
//     if (!couponInput.trim()) return;
//     setCouponLoading(true); setCouponError('');
//     try {
//       const { data } = await couponAPI.validate({ code: couponInput.trim(), subtotal: cart.subtotal });
//       setCouponData(data);
//       setCouponCode(couponInput.trim().toUpperCase());
//       toast.success(data.message);
//     } catch (e) {
//       setCouponError(e.response?.data?.message || 'Invalid coupon');
//       setCouponData(null); setCouponCode('');
//     } finally { setCouponLoading(false); }
//   };

//   const removeCoupon = () => {
//     setCouponCode(''); setCouponInput(''); setCouponData(null); setCouponError('');
//   };

//   const handleCheckout = () =>
//     payMethod === 'cod' ? handleCodCheckout() : handleRazorpayCheckout();

//   if (cart.items.length === 0) return (
//     <div className="container section">
//       <EmptyState
//         icon="🛍"
//         title="Your cart is empty"
//         message="Browse our collection and add some outfits!"
//         action={() => navigate('/browse')}
//         actionLabel="Browse Collection"
//       />
//     </div>
//   );

//   const STEPS = [
//     { key: 'cart',    label: 'Cart' },
//     { key: 'address', label: 'Delivery' },
//     { key: 'payment', label: 'Payment' },
//   ];
//   const stepIdx = STEPS.findIndex(s => s.key === step);

//   return (
//     <div className="container section fade-in" style={{ padding: 'clamp(24px, 4vw, 72px) clamp(14px, 4vw, 28px)' }}>
//       <div className="page-header" style={{ marginBottom: 20 }}>
//         <p className="eyebrow">Shopping Bag</p>
//         <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 'clamp(28px, 5vw, 40px)', fontStyle: 'italic' }}>
//           Your Cart
//         </h1>
//       </div>

//       {/* Verification banner */}
//       {!canCheckout && (
//         <div style={s.verifyBanner}>
//           <span style={{ fontSize: 22, flexShrink: 0 }}>🔒</span>
//           <div style={{ flex: 1, minWidth: 0 }}>
//             {!isEmailVerified ? (
//               <><div style={s.bannerTitle}>Email Verification Required</div>
//                 <div style={s.bannerText}>Please verify your email before placing an order.</div></>
//             ) : overLimit ? (
//               <><div style={s.bannerTitle}>Order Limit: ₹{orderLimit.toLocaleString('en-IN')} (Your current level: {trustLevel.name})</div>
//                 <div style={s.bannerText}>
//                   {nextLevel
//                     ? `Earn ${nextLevel.min - trustPoints} more Warba Score points to reach ${nextLevel.name} and unlock orders up to ₹${nextLevel.limit === Infinity ? 'unlimited' : nextLevel.limit.toLocaleString('en-IN')}.`
//                     : 'Verify your college email to place unlimited orders.'}
//                 </div></>
//             ) : null}
//           </div>

//         </div>
//       )}

//       {/* Step indicator */}
//       <div style={s.stepBar}>
//         {STEPS.map((st, i) => (
//           <button
//             key={st.key}
//             onClick={() => i < stepIdx && setStep(st.key)}
//             style={{
//               ...s.stepItem,
//               borderBottom: i <= stepIdx ? '2px solid var(--gold)' : '2px solid transparent',
//               color: i <= stepIdx ? 'var(--gold)' : 'var(--muted)',
//               cursor: i < stepIdx ? 'pointer' : 'default',
//               flex: 1, background: 'none', border: 'none',
//               borderBottom: i <= stepIdx ? '2px solid var(--gold)' : '2px solid transparent',
//             }}
//           >
//             <span style={s.stepNum(i <= stepIdx)}>{i + 1}</span>
//             <span style={s.stepLabel}>{st.label}</span>
//           </button>
//         ))}
//       </div>

//       {/* ── Two-column layout on desktop, stacked on mobile ── */}
//       <div style={s.layout} className="cart-layout">
//         {/* Main content */}
//         <div style={{ minWidth: 0 }}>
//           {/* STEP 1: CART ITEMS */}
//           {step === 'cart' && (
//             <>
//               {cart.items.map(item => (
//                 <CartItem
//                   key={item._id}
//                   item={item}
//                   onRemove={() => removeFromCart(item._id)}
//                   onUpdateQty={(qty) => updateCartItem(item._id, { quantity: qty })}
//                 />
//               ))}
//               {/* Coupon code — show here so discount is visible before checkout */}
//               <div style={{ border: '1px solid var(--border)', background: 'white', padding: '14px 16px', marginTop: 20 }}>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
//                   <span style={{ fontSize: 14 }}>🏷️</span>
//                   <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--ink)' }}>Have a Coupon?</span>
//                 </div>
//                 {couponData ? (
//                   <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f0faf0', border: '1px solid #c8e6c9', padding: '10px 14px' }}>
//                     <div>
//                       <span style={{ fontFamily: 'monospace', fontWeight: 700, fontSize: 13, color: '#1b5e20', letterSpacing: '0.06em' }}>{couponCode}</span>
//                       <span style={{ fontSize: 12, color: '#2d6a2d', marginLeft: 10 }}>— ₹{couponData.discount.toLocaleString('en-IN')} off applied ✓</span>
//                     </div>
//                     <button onClick={removeCoupon} style={{ fontSize: 10, fontWeight: 700, color: '#b71c1c', background: 'none', border: 'none', cursor: 'pointer', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Remove</button>
//                   </div>
//                 ) : (
//                   <div>
//                     <div className="coupon-input-row" style={{ display: 'flex', gap: 8 }}>
//                       <input
//                         className="input"
//                         style={{ flex: 1, textTransform: 'uppercase', letterSpacing: '0.06em', fontSize: 13 }}
//                         placeholder="Enter coupon code"
//                         value={couponInput}
//                         onChange={e => { setCouponInput(e.target.value.toUpperCase()); setCouponError(''); }}
//                         onKeyDown={e => e.key === 'Enter' && applyCoupon()}
//                       />
//                       <button onClick={applyCoupon} disabled={couponLoading || !couponInput.trim()}
//                         style={{ padding: '0 18px', fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', background: 'var(--ink)', color: 'var(--gold)', border: 'none', cursor: couponLoading ? 'wait' : 'pointer', opacity: !couponInput.trim() ? 0.5 : 1 }}>
//                         {couponLoading ? '...' : 'Apply'}
//                       </button>
//                     </div>
//                     {couponError && <div style={{ fontSize: 11, color: '#c62828', marginTop: 6 }}>{couponError}</div>}
//                   </div>
//                 )}
//               </div>

//               <button
//                 className="btn btn-primary w-full"
//                 style={{ marginTop: 16 }}
//                 onClick={() => setStep('address')}
//                 disabled={!canCheckout}
//               >
//                 {canCheckout ? 'Continue to Delivery →' : '🔒 Verify Identity to Continue'}
//               </button>
//             </>
//           )}

//           {/* STEP 2: ADDRESS */}
//           {step === 'address' && (
//             <SmartAddressStep
//               address={address}
//               setAddress={setAddress}
//               user={user}
//               onBack={() => setStep('cart')}
//               onContinue={() => {
//                 if (!validateAddress()) return;
//                 setShowSavePrompt(true);
//               }}
//               showSavePrompt={showSavePrompt}
//               setShowSavePrompt={setShowSavePrompt}
//               onProceedToPayment={() => setStep('payment')}
//             />
//           )}

//           {/* STEP 3: PAYMENT */}
//           {step === 'payment' && (
//             <div>
//               {/* Security deposit notice */}
//               <div style={{ background: '#f0f7f0', border: '1px solid #c8e6c9', padding: '11px 14px', marginBottom: 14, display: 'flex', gap: 10, alignItems: 'center' }}>
//                 <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="2" style={{ flexShrink: 0 }}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
//                 <div style={{ fontSize: 12, color: '#1b5e20' }}>
//                   <strong>₹{cart.totalDeposit?.toLocaleString('en-IN')} security deposit included</strong> — 100% refundable after safe return.
//                 </div>
//               </div>

//               {/* Amazon-style two-column payment panel */}
//               <div className="payment-panel" style={{ border: '1px solid #ddd', background: '#fff', display: 'flex', minHeight: 320 }}>

//                 {/* LEFT — vertical method list */}
//                 <div className="payment-panel-left" style={{ width: 200, flexShrink: 0, borderRight: '1px solid #e8e8e8' }}>
//                   <div style={{ padding: '12px 14px', background: '#f7f7f7', borderBottom: '1px solid #e8e8e8' }}>
//                     <div style={{ fontSize: 11, fontWeight: 700, color: '#555', letterSpacing: '0.08em', textTransform: 'uppercase' }}>Payment Method</div>
//                   </div>
//                   {[
//                     { key: 'upi',        label: 'UPI',           sub: 'GPay, PhonePe, Paytm' },
//                     { key: 'card',       label: 'Credit / Debit Card', sub: 'Visa, Mastercard, Rupay' },
//                     { key: 'netbanking', label: 'Net Banking',   sub: 'All major banks' },
//                     { key: 'wallet',     label: 'Wallets',       sub: 'Paytm, Mobikwik & more' },
//                     { key: 'cod',        label: 'Cash on Delivery', sub: codEnabled ? 'Pay at doorstep' : 'Unavailable', disabled: !codEnabled },
//                   ].map(method => (
//                     <div key={method.key}
//                       onClick={() => !method.disabled && setPayMethod(method.key)}
//                       className={`payment-method-item${payMethod === method.key ? ' payment-method-item-active' : ''}`}
//                       style={{
//                         padding: '13px 14px',
//                         borderBottom: '1px solid #f0f0f0',
//                         cursor: method.disabled ? 'not-allowed' : 'pointer',
//                         background: payMethod === method.key ? '#fffbf2' : '#fff',
//                         borderLeft: payMethod === method.key ? '3px solid #e8a838' : '3px solid transparent',
//                         opacity: method.disabled ? 0.45 : 1,
//                         transition: 'all 0.15s',
//                       }}>
//                       <div style={{ fontSize: 12, fontWeight: payMethod === method.key ? 700 : 500, color: payMethod === method.key ? '#b8860b' : '#111' }}>
//                         {method.label}
//                       </div>
//                       <div style={{ fontSize: 10, color: '#999', marginTop: 2 }}>{method.sub}</div>
//                     </div>
//                   ))}
//                 </div>

//                 {/* RIGHT — detail panel for selected method */}
//                 <div className="payment-panel-right" style={{ flex: 1, padding: '18px 20px' }}>

//                   {/* UPI */}
//                   {payMethod === 'upi' && (
//                     <PayDetail
//                       title="Pay via UPI"
//                       desc="Enter your UPI ID or scan QR code at checkout. Instant payment, no extra charges."
//                       items={['Google Pay', 'PhonePe', 'Paytm UPI', 'BHIM', 'Any UPI app']}
//                       note="You will be redirected to Razorpay to complete payment securely."
//                     />
//                   )}

//                   {/* Card */}
//                   {payMethod === 'card' && (
//                     <PayDetail
//                       title="Credit / Debit Card"
//                       desc="Pay securely using your card. All major cards accepted."
//                       items={['Visa', 'Mastercard', 'Rupay', 'American Express', 'Maestro']}
//                       note="Card details are entered on Razorpay's secure page — we never store your card info."
//                     />
//                   )}

//                   {/* Net Banking */}
//                   {payMethod === 'netbanking' && (
//                     <PayDetail
//                       title="Net Banking"
//                       desc="Pay directly from your bank account using internet banking."
//                       items={['SBI', 'HDFC Bank', 'ICICI Bank', 'Axis Bank', 'Kotak', '50+ more banks']}
//                       note="You will be redirected to your bank's secure login page."
//                     />
//                   )}

//                   {/* Wallet */}
//                   {payMethod === 'wallet' && (
//                     <PayDetail
//                       title="Mobile Wallets"
//                       desc="Pay using your digital wallet balance."
//                       items={['Paytm Wallet', 'Mobikwik', 'Freecharge', 'Airtel Money', 'JioMoney']}
//                       note="Wallet must have sufficient balance to complete the payment."
//                     />
//                   )}

//                   {/* COD */}
//                   {payMethod === 'cod' && (
//                     <div>
//                       <div style={{ fontSize: 14, fontWeight: 700, color: '#111', marginBottom: 8 }}>Cash on Delivery</div>
//                       <div style={{ fontSize: 12, color: '#555', lineHeight: 1.8, marginBottom: 14 }}>
//                         Pay in cash when your order arrives at your door. No online payment required.
//                       </div>
//                       <div style={{ background: '#fafafa', border: '1px solid #ebebeb', padding: '12px 14px', fontSize: 12, color: '#444', lineHeight: 1.9 }}>
//                         <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', paddingBottom: 6, marginBottom: 6 }}>
//                           <span>Rental amount</span>
//                           <span>₹{cart.subtotal?.toLocaleString('en-IN')}</span>
//                         </div>
//                         <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', paddingBottom: 6, marginBottom: 6 }}>
//                           <span>Refundable deposit</span>
//                           <span>₹{cart.totalDeposit?.toLocaleString('en-IN')}</span>
//                         </div>
//                         <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700, color: '#111' }}>
//                           <span>Total to pay in cash</span>
//                           <span>₹{cart.grandTotal?.toLocaleString('en-IN')}</span>
//                         </div>
//                       </div>
//                       <div style={{ fontSize: 11, color: '#aaa', marginTop: 10 }}>
//                         Deposit refunded within 3–5 days after safe return and inspection.
//                       </div>
//                     </div>
//                   )}

//                   {/* SSL note at bottom */}
//                   <div style={{ marginTop: 'auto', paddingTop: 16, borderTop: '1px solid #f0f0f0', marginTop: 20, display: 'flex', alignItems: 'center', gap: 6 }}>
//                     <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
//                     <span style={{ fontSize: 11, color: '#bbb' }}>
//                       {payMethod === 'cod' ? 'No online payment required for COD orders.' : 'All payments processed securely via Razorpay · 256-bit SSL'}
//                     </span>
//                   </div>
//                 </div>
//               </div>

//               {/* Action buttons */}
//               <div style={{ ...s.btnRow, marginTop: 14 }}>
//                 <button className="btn btn-outline" onClick={() => setStep('address')} disabled={processing}>← Back</button>
//                 <button
//                   className="btn btn-gold btn-lg"
//                   style={{ flex: 1 }}
//                   onClick={handleCheckout}
//                   disabled={processing}
//                 >
//                   {processing ? (
//                     <><Spinner size="sm" /> {payMethod === 'cod' ? 'Placing Order...' : 'Opening Payment...'}</>
//                   ) : payMethod === 'cod'
//                     ? `Place Order — ₹${cart.grandTotal?.toLocaleString('en-IN')}`
//                     : `Continue to Pay ₹${cart.grandTotal?.toLocaleString('en-IN')} →`
//                   }
//                 </button>
//               </div>
//               <p style={{ fontSize: 11, color: '#aaa', textAlign: 'center', marginTop: 10, lineHeight: 1.6 }}>
//                 By placing your order you agree to Warbadobe Rentals' <a href="/terms" style={{ color: '#888' }}>terms</a> and <a href="/refund-policy" style={{ color: '#888' }}>refund policy</a>.
//               </p>
//             </div>
//           )}
//         </div>

//         {/* ── Order Summary Sidebar ── */}
//         <div style={s.sidebar}>
//           {/* Mobile: collapsible summary */}
//           <div style={s.summaryToggle} className="hide-desktop cart-summary-mobile-toggle" onClick={() => setSummaryOpen(o => !o)}>
//             <span style={{ fontSize: 13, fontWeight: 600 }}>Order Summary</span>
//             <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//               <strong style={{ color: 'var(--gold)' }}>₹{cart.grandTotal?.toLocaleString('en-IN')}</strong>
//               <span style={{ fontSize: 12 }}>{summaryOpen ? '▲' : '▼'}</span>
//             </span>
//           </div>

//           <div style={s.summaryBody(summaryOpen)} className="cart-summary-body">
//             <div style={s.card}>
//               <h3 style={{ ...s.cardTitle, display: 'none' }} className="hide-mobile">Order Summary</h3>
//               <h3 style={{ ...s.cardTitle }} className="hide-desktop" hidden={!summaryOpen}>Order Summary</h3>

//               {cart.items.map(item => (
//                 <div key={item._id} style={{ display: 'flex', gap: 10, marginBottom: 12 }}>
//                   <div style={{ width: 44, height: 52, flexShrink: 0, background: 'var(--cream)', overflow: 'hidden', border: '1px solid var(--border)' }}>
//                     {item.productImage
//                       ? <img src={item.productImage} alt={item.productName} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//                       : <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', fontSize: 16 }}>👗</span>
//                     }
//                   </div>
//                   <div style={{ flex: 1, minWidth: 0 }}>
//                     <div style={{ fontWeight: 500, fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.productName}</div>
//                     <div style={{ color: 'var(--muted)', fontSize: 10, marginTop: 2 }}>
//                       Size {item.size} · {item.rentalDurationLabel}{item.quantity > 1 && ` · ×${item.quantity}`}
//                     </div>
//                     {item.deliveryDate && (
//                       <div style={{ fontSize: 10, color: 'var(--ink)', marginTop: 3, display: 'flex', gap: 6 }}>
//                         <span style={{ color: 'var(--gold)', fontWeight: 700 }}>Delivery</span>
//                         <span>{(() => { try { return new Date(item.deliveryDate).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }); } catch { return '—'; } })()}</span>
//                         {item.returnDate && (
//                           <>
//                             <span style={{ color: 'var(--border)' }}>·</span>
//                             <span style={{ color: 'var(--muted)' }}>Return by {(() => { try { return new Date(item.returnDate).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }); } catch { return '—'; } })()}</span>
//                           </>
//                         )}
//                       </div>
//                     )}
//                     <div style={{ fontSize: 12, marginTop: 4 }}>
//                       ₹{(item.rentalPrice * (item.quantity || 1))?.toLocaleString('en-IN')}
//                       <span style={{ color: 'var(--muted)', fontSize: 10 }}> +₹{(item.securityDeposit * (item.quantity || 1))?.toLocaleString('en-IN')} dep.</span>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//               <hr className="divider" />
//               <PriceRow label="Rental Subtotal"       amount={cart.subtotal} />
//               <PriceRow label="Refundable Deposit"    amount={cart.totalDeposit} />
//               {couponData && (
//                 <PriceRow label={`Coupon (${couponCode})`} amount={-couponData.discount} style={{ color: '#2d6a2d', fontWeight: 700 }} />
//               )}
//               {deliveryInfo.charge > 0 && (
//                 <PriceRow label={deliveryInfo.label || 'Delivery'} amount={deliveryInfo.charge} />
//               )}
//               <hr className="divider" />
//               <PriceRow label="Total (incl. deposit)" amount={(cart.grandTotal || 0) - (couponData?.discount || 0) + (deliveryInfo?.charge || 0)} bold gold />
//               <p style={{ fontSize: 10, color: 'var(--muted)', marginTop: 8, lineHeight: 1.7 }}>
//                 Deposit refunded within 3–5 days after return.
//               </p>
//             </div>

//             {/* Verification status */}
//             <div style={{ ...s.card, padding: '12px 16px', marginTop: 12 }}>
//               <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--muted)', marginBottom: 10 }}>
//                 Verification Status
//               </div>
//               <VerifyRow icon="📧" label="Email"    done={isEmailVerified} />
//               {!canCheckout && (
//                 <Link to="/profile" className="btn btn-outline btn-sm w-full" style={{ marginTop: 10 }}>
//                   Complete Verification
//                 </Link>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Cart Item ─────────────────────────────────────────────────────────────────
// function CartItem({ item, onRemove, onUpdateQty }) {
//   const [removing,  setRemoving]  = useState(false);
//   const [updatingQ, setUpdatingQ] = useState(false);

//   const fmtDate = (d) => { try { return format(new Date(d), 'dd MMM yyyy'); } catch { return '—'; } };

//   const handleRemove = async () => {
//     setRemoving(true);
//     try { await onRemove(); }
//     catch { toast.error('Could not remove item.'); setRemoving(false); }
//   };

//   const changeQty = async (delta) => {
//     const newQty = (item.quantity || 1) + delta;
//     if (newQty < 1) return;
//     setUpdatingQ(true);
//     try { await onUpdateQty(newQty); }
//     catch { toast.error('Could not update quantity.'); }
//     finally { setUpdatingQ(false); }
//   };

//   return (
//     <div style={s.cartItem}>
//       <div style={s.cartImg}>
//         {item.productImage
//           ? <img src={item.productImage} alt={item.productName} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//           : <span style={{ fontSize: 24 }}>👗</span>
//         }
//       </div>

//       <div style={{ flex: 1, minWidth: 0 }}>
//         <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 17, marginBottom: 6, lineHeight: 1.3 }}>
//           {item.productName || 'Product'}
//         </div>

//         <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 8 }}>
//           <span className="tag">Size {item.size}</span>
//           <span className="tag">{item.rentalDurationLabel}</span>
//         </div>

//         <div style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.9 }}>
//           📅 Delivery: <strong>{fmtDate(item.deliveryDate)}</strong><br />
//           📦 Return by: <strong>{fmtDate(item.returnDate)}</strong>
//         </div>

//         {/* Bottom row: qty + price + remove */}
//         <div style={s.cartItemBottom}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//             <span style={{ fontSize: 10, color: 'var(--muted)', letterSpacing: '0.06em' }}>QTY</span>
//             <div style={s.qtyWrap}>
//               <button style={s.qtyBtn} onClick={() => changeQty(-1)} disabled={updatingQ || (item.quantity || 1) <= 1}>−</button>
//               <span style={s.qtyNum}>{updatingQ ? '…' : (item.quantity || 1)}</span>
//               <button style={s.qtyBtn} onClick={() => changeQty(1)}  disabled={updatingQ || (item.quantity || 1) >= 10}>+</button>
//             </div>
//           </div>

//           <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
//             <div style={{ textAlign: 'right' }}>
//               <div style={{ fontWeight: 700, fontSize: 15 }}>₹{(item.rentalPrice * (item.quantity || 1))?.toLocaleString('en-IN')}</div>
//               <div style={{ fontSize: 10, color: 'var(--muted)' }}>+₹{(item.securityDeposit * (item.quantity || 1))?.toLocaleString('en-IN')} dep.</div>
//             </div>
//             <button onClick={handleRemove} disabled={removing} style={s.removeBtn}>
//               {removing ? '...' : '✕'}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// function PayDetail({ title, desc, items, note }) {
//   return (
//     <div>
//       <div style={{ fontSize: 14, fontWeight: 700, color: '#111', marginBottom: 8 }}>{title}</div>
//       <div style={{ fontSize: 12, color: '#555', lineHeight: 1.8, marginBottom: 14 }}>{desc}</div>
//       <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
//         {items.map((item, i) => (
//           <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 0', borderBottom: '1px solid #f5f5f5' }}>
//             <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#e8a838', flexShrink: 0 }} />
//             <span style={{ fontSize: 12, color: '#333' }}>{item}</span>
//           </div>
//         ))}
//       </div>
//       {note && (
//         <div style={{ marginTop: 14, fontSize: 11, color: '#888', lineHeight: 1.7, padding: '8px 12px', background: '#fafafa', border: '1px solid #ebebeb' }}>
//           {note}
//         </div>
//       )}
//     </div>
//   );
// }

// function PayMethodCard({ active, onClick, icon, title, subtitle, badge }) {
//   return (
//     <div onClick={onClick} style={{ ...s.payCard, border: `2px solid ${active ? 'var(--gold)' : 'var(--border)'}`, background: active ? 'rgba(184,146,74,0.05)' : 'white' }}>
//       <span style={{ fontSize: 26, flexShrink: 0 }}>{icon}</span>
//       <div style={{ flex: 1, minWidth: 0 }}>
//         <div style={{ fontWeight: 600, fontSize: 13, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
//           {title}
//           {badge && <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: '0.1em', color: 'var(--gold)', border: '1px solid var(--gold)', padding: '1px 6px' }}>{badge}</span>}
//         </div>
//         <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>{subtitle}</div>
//       </div>
//       <div style={{ width: 18, height: 18, borderRadius: '50%', flexShrink: 0, border: `2px solid ${active ? 'var(--gold)' : 'var(--border)'}`, background: active ? 'var(--gold)' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//         {active && <div style={{ width: 7, height: 7, borderRadius: '50%', background: 'white' }} />}
//       </div>
//     </div>
//   );
// }

// function VerifyRow({ icon, label, done, pending }) {
//   return (
//     <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
//       <span style={{ fontSize: 14 }}>{icon}</span>
//       <span style={{ fontSize: 12, flex: 1 }}>{label}</span>
//       <span style={{ fontSize: 11, fontWeight: 700, color: done ? '#1b5e20' : pending ? '#856404' : '#b71c1c' }}>
//         {done ? '✓ Verified' : pending ? '⏳ Pending' : '✗ Required'}
//       </span>
//     </div>
//   );
// }

// const s = {
//   layout:         { display: 'grid', gridTemplateColumns: '1fr clamp(260px, 30%, 340px)', gap: 28, alignItems: 'start' },
//   sidebar:        { position: 'sticky', top: 80, display: 'flex', flexDirection: 'column' },
//   summaryToggle:  { display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'white', border: '1px solid var(--border)', padding: '12px 16px', cursor: 'pointer', marginBottom: 0 },
//   summaryBody:    (open) => ({ display: open ? 'block' : 'none' }),
//   card:           { background: 'white', border: '1px solid var(--border)', padding: 20 },
//   cardTitle:      { fontFamily: "'Cormorant Garamond', serif", fontSize: 20, marginBottom: 14 },
//   cartItem:       { display: 'flex', gap: 14, padding: 16, background: 'white', border: '1px solid var(--border)', marginBottom: 10 },
//   cartImg:        { width: 80, height: 96, background: 'var(--cream)', flexShrink: 0, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid var(--border)' },
//   cartItemBottom: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 12, flexWrap: 'wrap', gap: 8 },
//   qtyWrap:        { display: 'flex', alignItems: 'center', border: '1px solid var(--border)', background: 'var(--cream)' },
//   qtyBtn:         { width: 32, height: 32, background: 'none', border: 'none', cursor: 'pointer', fontSize: 16, fontWeight: 700, color: 'var(--ink)', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 32 },
//   qtyNum:         { width: 32, textAlign: 'center', fontSize: 13, fontWeight: 600, borderLeft: '1px solid var(--border)', borderRight: '1px solid var(--border)', lineHeight: '32px' },
//   removeBtn:      { background: 'none', border: '1px solid #f5c6cb', color: '#c0392b', cursor: 'pointer', fontSize: 12, padding: '6px 12px', transition: 'all 0.15s', minHeight: 36, minWidth: 36, display: 'flex', alignItems: 'center', justifyContent: 'center' },
//   verifyBanner:   { display: 'flex', gap: 12, alignItems: 'flex-start', background: '#fff8e1', border: '1px solid #ffc107', padding: '14px 16px', marginBottom: 20, flexWrap: 'wrap' },
//   bannerTitle:    { fontWeight: 700, fontSize: 13, color: '#856404' },
//   bannerText:     { fontSize: 12, color: '#856404', marginTop: 2 },
//   stepBar:        { display: 'flex', marginBottom: 28, borderBottom: '1px solid var(--border)', overflowX: 'auto' },
//   stepItem:       { padding: '11px 8px', fontSize: 11, fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: 6, justifyContent: 'center', whiteSpace: 'nowrap', background: 'none' },
//   stepNum:        (active) => ({ width: 20, height: 20, borderRadius: '50%', background: active ? 'var(--gold)' : 'var(--border)', color: active ? 'var(--ink)' : 'var(--muted)', fontSize: 10, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }),
//   stepLabel:      { fontSize: 11 },
//   formGrid2:      { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12 },
//   formGrid3:      { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: 12 },
//   btnRow:         { display: 'flex', gap: 10, marginTop: 12, flexWrap: 'wrap' },
//   depositNotice:  { display: 'flex', gap: 10, alignItems: 'flex-start', background: '#e8f5e9', border: '1px solid #a5d6a7', padding: 12, marginBottom: 18 },
//   codNotice:      { display: 'flex', gap: 10, alignItems: 'flex-start', background: '#e3f2fd', border: '1px solid #90caf9', padding: 12, marginBottom: 14 },
//   stripeCta:      { background: 'var(--cream)', border: '1px solid var(--border)', padding: '10px 12px', marginBottom: 4 },
//   payCard:        { display: 'flex', gap: 12, alignItems: 'center', padding: '14px 16px', cursor: 'pointer', transition: 'all 0.2s' },
//   payCardDisabled:{ display: 'flex', gap: 12, alignItems: 'center', padding: '14px 16px', border: '2px solid var(--border)', background: '#fafafa', opacity: 0.55, cursor: 'not-allowed' },
// };

// // ── Smart Address Step ────────────────────────────────────────────────────────
// function SmartAddressStep({ address, setAddress, user, onBack, onContinue, showSavePrompt, setShowSavePrompt, onProceedToPayment }) {
//   const [locating,        setLocating]        = useState(false);
//   const [locError,        setLocError]        = useState('');
//   const [pincodeLoading,  setPincodeLoading]  = useState(false);
//   const [selectedSaved,   setSelectedSaved]   = useState(null); // addrId | 'gps' | null
//   const [savedAddresses,  setSavedAddresses]  = useState(user?.savedAddresses || []);
//   const [showAddrPicker,  setShowAddrPicker]  = useState(false);
//   const [addrLoading,     setAddrLoading]     = useState(false);

//   const defaultAddr = savedAddresses.find(a => a.isDefault) || savedAddresses[0];
//   const hasSavedAddresses = savedAddresses.length > 0;

//   // Always fetch fresh addresses from API — auth context user may be stale from localStorage
//   useEffect(() => {
//     setAddrLoading(true);
//     addressAPI.getAll()
//       .then(({ data }) => {
//         const addrs = data.addresses || [];
//         setSavedAddresses(addrs);
//         // Auto-select default if address not yet filled
//         if (!address.street) {
//           const def = addrs.find(a => a.isDefault) || addrs[0];
//           if (def) applyAddr(def);
//         }
//       })
//       .catch(() => {}) // non-fatal — fallback to manual entry
//       .finally(() => setAddrLoading(false));
//   }, []); // eslint-disable-line

//   const applyAddr = (addr) => {
//     setAddress(a => ({
//       ...a,
//       name:    addr.name    || a.name || '',
//       phone:   addr.phone   || a.phone || '',
//       street:  addr.street  || '',
//       city:    addr.city    || '',
//       state:   addr.state   || '',
//       pincode: addr.pincode || '',
//     }));
//     setSelectedSaved(addr._id);
//     setLocError('');
//     setShowAddrPicker(false);
//   };

//   const useCurrentLocation = () => {
//     if (!navigator.geolocation) {
//       setLocError('Geolocation is not supported by your browser.');
//       return;
//     }
//     setLocating(true);
//     setLocError('');
//     navigator.geolocation.getCurrentPosition(
//       async (pos) => {
//         try {
//           const { latitude, longitude } = pos.coords;
//           // Use OpenStreetMap Nominatim (free, no API key needed)
//           const res = await fetch(
//             `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json&addressdetails=1`,
//             { headers: { 'Accept-Language': 'en' } }
//           );
//           const data = await res.json();
//           const a = data.address || {};

//           const street  = [a.road, a.neighbourhood, a.suburb].filter(Boolean).join(', ') || '';
//           const city    = a.city || a.town || a.village || a.county || '';
//           const state   = a.state || '';
//           const pincode = a.postcode || '';

//           setAddress(prev => ({
//             ...prev,
//             street:  street  || prev.street,
//             city:    city    || prev.city,
//             state:   state   || prev.state,
//             pincode: pincode || prev.pincode,
//           }));
//           setSelectedSaved('gps');
//           if (!city) setLocError('Could not detect full address. Please fill remaining fields.');
//         } catch {
//           setLocError('Could not fetch address. Please enter manually.');
//         } finally {
//           setLocating(false);
//         }
//       },
//       (err) => {
//         setLocating(false);
//         if (err.code === 1) setLocError('Location access denied. Please allow location or enter address manually.');
//         else setLocError('Could not get location. Please enter address manually.');
//       },
//       { timeout: 10000, enableHighAccuracy: true }
//     );
//   };

//   // Auto-fill city/state from pincode using postal API
//   const handlePincodeChange = async (val) => {
//     setAddress(a => ({ ...a, pincode: val }));
//     if (val.length === 6 && /^\d{6}$/.test(val)) {
//       setPincodeLoading(true);
//       try {
//         const res  = await fetch(`https://api.postalpincode.in/pincode/${val}`);
//         const data = await res.json();
//         if (data[0]?.Status === 'Success') {
//           const post = data[0].PostOffice?.[0];
//           if (post) {
//             setAddress(a => ({
//               ...a,
//               city:  post.District || a.city,
//               state: post.State    || a.state,
//             }));
//           }
//         }
//       } catch {}
//       finally { setPincodeLoading(false); }
//     }
//   };

//   return (
//     <div style={s.card}>
//       <h3 style={s.cardTitle}>Delivery Address</h3>

//       {/* ── Address options row ── */}
//       <div style={{ display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap' }}>

//         {/* GPS button */}
//         <button
//           onClick={useCurrentLocation}
//           disabled={locating}
//           style={{
//             display: 'flex', alignItems: 'center', gap: 8,
//             padding: '10px 16px', border: `2px solid ${selectedSaved === 'gps' ? 'var(--gold)' : 'var(--border)'}`,
//             background: selectedSaved === 'gps' ? 'rgba(184,146,74,0.06)' : 'white',
//             cursor: locating ? 'wait' : 'pointer', fontSize: 13, fontWeight: 600,
//             color: selectedSaved === 'gps' ? 'var(--gold)' : 'var(--ink)',
//             transition: 'all 0.15s', flex: 1, minWidth: 160, justifyContent: 'center',
//           }}
//         >
//           <span style={{ fontSize: 18 }}>📍</span>
//           {locating ? 'Detecting...' : 'Use My Location'}
//         </button>

//         {/* Saved addresses button */}
//         {(hasSavedAddresses || addrLoading) && (
//           <button
//             onClick={() => !addrLoading && setShowAddrPicker(p => !p)}
//             style={{
//               display: 'flex', alignItems: 'center', gap: 8,
//               padding: '10px 16px', border: `2px solid ${savedAddresses.some(a => a._id === selectedSaved) ? 'var(--gold)' : 'var(--border)'}`,
//               background: savedAddresses.some(a => a._id === selectedSaved) ? 'rgba(184,146,74,0.06)' : 'white',
//               cursor: 'pointer', fontSize: 13, fontWeight: 600,
//               color: savedAddresses.some(a => a._id === selectedSaved) ? 'var(--gold)' : 'var(--ink)',
//               transition: 'all 0.15s', flex: 1, minWidth: 160, justifyContent: 'center',
//             }}
//           >
//             <span style={{ fontSize: 18 }}>🏠</span>
//             {addrLoading ? 'Loading addresses…' : savedAddresses.length === 1 ? 'Saved Address' : `Saved Addresses (${savedAddresses.length})`}
//             {!addrLoading && <span style={{ fontSize: 10, marginLeft: 4 }}>{showAddrPicker ? '▲' : '▼'}</span>}
//           </button>
//         )}
//       </div>

//       {/* Saved address picker dropdown */}
//       {showAddrPicker && hasSavedAddresses && (
//         <div style={{ border: '1px solid var(--border)', marginBottom: 16, overflow: 'hidden' }}>
//           {savedAddresses.map(addr => (
//             <div key={addr._id} onClick={() => applyAddr(addr)}
//               style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid var(--border)',
//                 background: selectedSaved === addr._id ? 'rgba(184,146,74,0.06)' : 'white',
//                 transition: 'background 0.15s' }}
//               onMouseEnter={e => { if (selectedSaved !== addr._id) e.currentTarget.style.background = '#fafafa'; }}
//               onMouseLeave={e => { if (selectedSaved !== addr._id) e.currentTarget.style.background = 'white'; }}>
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <div>
//                   <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: 2 }}>
//                     <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--ink)' }}>{addr.label || 'Address'}</span>
//                     {addr.isDefault && <span style={{ fontSize: 9, color: 'var(--gold)', fontWeight: 700 }}>DEFAULT</span>}
//                   </div>
//                   {addr.name && <div style={{ fontSize: 13, fontWeight: 600 }}>{addr.name}</div>}
//                   <div style={{ fontSize: 12, color: '#555' }}>{addr.street}, {addr.city} — {addr.pincode}</div>
//                   {addr.phone && <div style={{ fontSize: 11, color: 'var(--muted)' }}>📞 {addr.phone}</div>}
//                 </div>
//                 {selectedSaved === addr._id && <span style={{ color: 'var(--gold)', fontWeight: 700, fontSize: 16 }}>✓</span>}
//               </div>
//             </div>
//           ))}
//         </div>
//       )}

//       {/* Selected saved address preview (when picker is closed) */}
//       {!showAddrPicker && savedAddresses.some(a => a._id === selectedSaved) && (() => {
//         const sel = savedAddresses.find(a => a._id === selectedSaved);
//         return (
//           <div style={{ background: 'rgba(184,146,74,0.06)', border: '1px solid rgba(184,146,74,0.3)', padding: '10px 14px', marginBottom: 16, fontSize: 13, color: '#555', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
//             <div>
//               <div style={{ fontWeight: 600, marginBottom: 2 }}>{sel.name || address.name}</div>
//               <div>{sel.street}, {sel.city}</div>
//               {sel.phone && <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>📞 {sel.phone}</div>}
//             </div>
//             <span style={{ fontSize: 11, color: 'var(--gold)', fontWeight: 700 }}>✓ Selected</span>
//           </div>
//         );
//       })()}

//       {/* GPS success notice */}
//       {selectedSaved === 'gps' && !locating && (
//         <div style={{ background: '#e8f5e9', border: '1px solid #a5d6a7', padding: '8px 14px', marginBottom: 16, fontSize: 12, color: '#1b5e20' }}>
//           📍 Location detected — please verify the fields below and fill in your house/flat number.
//         </div>
//       )}

//       {/* Location error */}
//       {locError && (
//         <div style={{ background: '#fff8e1', border: '1px solid #ffc107', padding: '8px 14px', marginBottom: 16, fontSize: 12, color: '#856404' }}>
//           ⚠️ {locError}
//         </div>
//       )}

//       <div style={{ borderTop: '1px solid var(--border)', paddingTop: 16, marginBottom: 4 }}>
//         <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--muted)', marginBottom: 14 }}>
//           {selectedSaved ? 'Confirm Details' : 'Enter Address Manually'}
//         </div>
//       </div>

//       {/* Name + Phone */}
//       <div style={s.formGrid2}>
//         {[
//           { key: 'name',  label: 'Full Name *',    placeholder: 'Recipient name' },
//           { key: 'phone', label: 'Phone Number *',  placeholder: '9876543210' },
//         ].map(f => (
//           <div key={f.key} className="form-group">
//             <label className="form-label">{f.label}</label>
//             <input className="input" value={address[f.key]} placeholder={f.placeholder}
//               onChange={e => setAddress(a => ({ ...a, [f.key]: e.target.value }))} />
//           </div>
//         ))}
//       </div>

//       {/* Street */}
//       <div className="form-group">
//         <label className="form-label">House / Flat / Building *</label>
//         <input className="input" value={address.street} placeholder="e.g. 42B, Sunrise Apartments, MG Road"
//           onChange={e => setAddress(a => ({ ...a, street: e.target.value }))} />
//       </div>

//       {/* Pincode + City + State */}
//       <div style={s.formGrid3}>
//         <div className="form-group">
//           <label className="form-label">Pincode *</label>
//           <div style={{ position: 'relative' }}>
//             <input className="input" value={address.pincode} placeholder="141001" maxLength={6}
//               onChange={e => handlePincodeChange(e.target.value)} />
//             {pincodeLoading && (
//               <span style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', fontSize: 11, color: 'var(--gold)' }}>...</span>
//             )}
//           </div>
//         </div>
//         <div className="form-group">
//           <label className="form-label">City *</label>
//           <input className="input" value={address.city} placeholder="Ludhiana"
//             onChange={e => setAddress(a => ({ ...a, city: e.target.value }))} />
//         </div>
//         <div className="form-group">
//           <label className="form-label">State *</label>
//           <input className="input" value={address.state} placeholder="Punjab"
//             onChange={e => setAddress(a => ({ ...a, state: e.target.value }))} />
//         </div>
//       </div>

//       <div style={s.btnRow}>
//         <button className="btn btn-outline" onClick={onBack}>← Back</button>
//         <button className="btn btn-primary" style={{ flex: 1 }} onClick={onContinue}>
//           Continue to Payment →
//         </button>
//       </div>

//       {/* ── Save Address Prompt Modal ── */}
//       {showSavePrompt && (
//         <SaveAddressPrompt
//           address={address}
//           isNewAddress={!savedAddresses.some(a => a._id === selectedSaved)}
//           onSave={async (label, name, phone) => {
//             try {
//               await addressAPI.add({
//                 label,
//                 name:    name    || address.name    || '',
//                 phone:   phone   || address.phone   || '',
//                 street:  address.street,
//                 city:    address.city,
//                 state:   address.state,
//                 pincode: address.pincode,
//                 isDefault: savedAddresses.length === 0,
//               });
//               toast.success('Address saved to your profile!');
//             } catch { /* non-fatal — proceed anyway */ }
//             setShowSavePrompt(false);
//             onProceedToPayment();
//           }}
//           onSkip={() => { setShowSavePrompt(false); onProceedToPayment(); }}
//         />
//       )}
//     </div>
//   );
// }

// // ── Save Address Prompt (modal overlay) ───────────────────────────────────────
// function SaveAddressPrompt({ address, isNewAddress, onSave, onSkip }) {
//   const [label,   setLabel]   = useState('Home');
//   const [name,    setName]    = useState(address.name  || '');
//   const [phone,   setPhone]   = useState(address.phone || '');
//   const [saving,  setSaving]  = useState(false);
//   const LABELS = ['Home', 'Work', 'Other'];

//   if (!isNewAddress) {
//     // Already a saved address selected — go straight through
//     setTimeout(onSkip, 0);
//     return null;
//   }

//   const handleSave = async () => {
//     if (phone && !/^[6-9]\d{9}$/.test(phone)) { toast.error('Enter a valid 10-digit mobile number.'); return; }
//     setSaving(true);
//     await onSave(label, name, phone);
//     setSaving(false);
//   };

//   return (
//     <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
//       <div style={{ background: 'white', width: '100%', maxWidth: 440, padding: 24, boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
//         {/* Header */}
//         <div style={{ marginBottom: 20 }}>
//           <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: '0.22em', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: 6 }}>Quick Save</div>
//           <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, fontWeight: 300, color: 'var(--ink)', marginBottom: 4 }}>Save this address?</div>
//           <div style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.6 }}>
//             <strong>{address.street}</strong><br />
//             {address.city}{address.state ? `, ${address.state}` : ''} — {address.pincode}
//           </div>
//         </div>

//         {/* Label selector */}
//         <div style={{ marginBottom: 14 }}>
//           <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--muted)', marginBottom: 8 }}>Label</div>
//           <div style={{ display: 'flex', gap: 8 }}>
//             {LABELS.map(l => (
//               <button key={l} onClick={() => setLabel(l)}
//                 style={{ padding: '6px 16px', fontSize: 12, border: '1px solid', cursor: 'pointer', transition: 'all 0.15s',
//                   borderColor: label === l ? 'var(--gold)' : 'var(--border)',
//                   background:  label === l ? 'rgba(184,146,74,0.08)' : 'white',
//                   color:       label === l ? 'var(--gold)' : 'var(--muted)',
//                   fontWeight:  label === l ? 700 : 400 }}>
//                 {l}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* Name */}
//         <div className="form-group" style={{ marginBottom: 12 }}>
//           <label className="form-label">Recipient Name</label>
//           <input className="input" value={name} placeholder="e.g. Riya Sharma"
//             onChange={e => setName(e.target.value)} />
//         </div>

//         {/* Phone */}
//         <div className="form-group" style={{ marginBottom: 20 }}>
//           <label className="form-label">Phone Number</label>
//           <input className="input" inputMode="tel" value={phone} placeholder="10-digit number"
//             onChange={e => setPhone(e.target.value.replace(/\D/g,'').slice(0,10))} />
//         </div>

//         {/* Buttons */}
//         <div style={{ display: 'flex', gap: 10 }}>
//           <button onClick={onSkip}
//             style={{ flex: 1, padding: '11px', fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', border: '1px solid var(--border)', background: 'none', color: 'var(--muted)', cursor: 'pointer' }}>
//             Skip
//           </button>
//           <button onClick={handleSave} disabled={saving}
//             style={{ flex: 2, padding: '11px', fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', background: 'var(--ink)', color: 'var(--cream)', border: 'none', cursor: saving ? 'wait' : 'pointer' }}>
//             {saving ? 'Saving…' : 'Save & Continue →'}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }




import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import { useAuth } from '../contexts/AuthContext';
import { paymentAPI, deliveryAPI, couponAPI, userAPI, addressAPI } from '../services/api';
import { PriceRow, EmptyState, Spinner } from '../components/shared/index';
import { format } from 'date-fns';
import toast from 'react-hot-toast';

export default function CartPage() {
  const { cart, removeFromCart, updateCartItem, clearCart } = useCart();
  const { user } = useAuth();
  const navigate  = useNavigate();

  const [step,       setStep]       = useState('cart');
  const [address,    setAddress]    = useState({
    name: user?.name || '', street: '', city: '', state: '', pincode: '', phone: user?.phone || ''
  });
  const [deliveryType, setDeliveryType] = useState('home');
  const COLLEGES = ['NIT Jalandhar',  'Others',];
  const NIT_HOSTELS = ['BH1', 'BH2', 'BH3', 'BH4', 'BH5', 'MBH A', 'MBH B', 'MBH F', 'Others', ];
  const [campus, setCampus] = useState({
    name: user?.name || '', phone: user?.phone || '',
    college: 'NIT Jalandhar', hostel: '', roomNo: '',
  });
  const [payMethod,  setPayMethod]  = useState('upi');
  const [codEnabled, setCodEnabled] = useState(false);
  const [processing,    setProcessing]    = useState(false);
  const [summaryOpen,   setSummaryOpen]    = useState(false);
  const [couponCode,    setCouponCode]    = useState('');
  const [showSavePrompt, setShowSavePrompt] = useState(false);
  const [couponInput,   setCouponInput]   = useState('');
  const [couponData,    setCouponData]    = useState(null);  // { discount, message, coupon }
  const [couponLoading, setCouponLoading] = useState(false);
  const [couponError,   setCouponError]   = useState('');
  const [deliveryInfo,  setDeliveryInfo]   = useState({ charge: 0, label: 'Delivery', freeAbove: null });

  const isEmailVerified   = user?.isEmailVerified;
  const isCollegeVerified = user?.isCollegeVerified;
  const collegeActive     = isCollegeVerified && user?.collegeExpiresAt && new Date(user.collegeExpiresAt) > new Date();
  const trustPoints       = user?.trustPoints || 0;
  // Trust level order limits (mirrors backend LEVELS)
  const TRUST_LIMITS = [
    { name: 'New',     min: 0,    max: 99,        limit: 399 },
    { name: 'Trusted', min: 100,  max: 299,        limit: 999 },
    { name: 'Silver',  min: 300,  max: 599,        limit: 2499 },
    { name: 'Gold',    min: 600,  max: 999,        limit: 4999 },
    { name: 'Elite',   min: 1000, max: Infinity,   limit: Infinity },
  ];
  const trustLevel    = TRUST_LIMITS.find(l => trustPoints >= l.min && trustPoints <= l.max) || TRUST_LIMITS[0];
  const orderLimit    = collegeActive ? Infinity : trustLevel.limit;
  const cartTotal     = cart.items?.reduce((s, i) => s + (i.rentalPrice || i.price || 0) * (i.quantity || 1), 0) || 0;
  const overLimit     = orderLimit !== Infinity && cartTotal > orderLimit;
  const nextLevel     = overLimit ? TRUST_LIMITS[TRUST_LIMITS.indexOf(trustLevel) + 1] : null;
  const canCheckout   = isEmailVerified && !overLimit;

  // Fetch delivery charge when address changes
  useEffect(() => {
    const { pincode, city } = address;
    if (!pincode && !city) return;
    deliveryAPI.getCharge({ pincode, city })
      .then(({ data }) => setDeliveryInfo({ charge: data.charge || 0, label: data.label || 'Delivery', freeAbove: data.freeAbove }))
      .catch(() => {});
  }, [address.pincode, address.city]);

  useEffect(() => {
    paymentAPI.getCodSettings()
      .then(({ data }) => setCodEnabled(data.codEnabled))
      .catch(() => {});
  }, []);

  const getShippingAddress = () => {
    if (deliveryType === 'campus') {
      return {
        name: campus.name, phone: campus.phone,
        street: `${campus.hostel} Hostel, Room ${campus.roomNo}`,
        city: campus.college, state: 'Campus Delivery', pincode: '000000',
        isCampusDelivery: true, college: campus.college,
        hostel: campus.hostel, roomNo: campus.roomNo,
      };
    }
    return address;
  };

  const validateAddress = () => {
    if (deliveryType === 'campus') {
      if (!campus.name || !campus.college || !campus.hostel || !campus.roomNo || !campus.phone) {
        toast.error('Please fill all campus delivery fields.'); return false;
      }
      if (!/^[6-9]\d{9}$/.test(campus.phone)) {
        toast.error('Please enter a valid 10-digit phone number.'); return false;
      }
      return true;
    }
    if (!address.name || !address.street || !address.city || !address.pincode || !address.phone) {
      toast.error('Please fill all address fields.'); return false;
    }
    if (!/^[6-9]\d{9}$/.test(address.phone)) {
      toast.error('Please enter a valid 10-digit phone number.'); return false;
    }
    if (!/^\d{6}$/.test(address.pincode)) {
      toast.error('Please enter a valid 6-digit pincode.'); return false;
    }
    return true;
  };

  // Load Razorpay script dynamically (only once)
  const loadRazorpay = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) { resolve(true); return; }
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload  = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handleRazorpayCheckout = async () => {
    if (!validateAddress()) return;
    setProcessing(true);

    try {
      // Load Razorpay SDK
      const loaded = await loadRazorpay();
      if (!loaded) {
        toast.error('Could not load payment gateway. Check your internet connection.');
        setProcessing(false);
        return;
      }

      // Step 1: Create Razorpay order on backend
      const { data } = await paymentAPI.createRazorpayOrder({ shippingAddress: getShippingAddress(), couponCode: couponCode || undefined });

      // Step 2: Open Razorpay modal
      const options = {
        key:         data.keyId,
        amount:      data.amount,          // paise
        currency:    data.currency,
        name:        'Warbadobe Rentals',
        description: 'Luxury Fashion Rental',
        image:       '/logo192.png',
        order_id:    data.orderId,
        prefill: {
          name:    data.userName  || user?.name  || '',
          email:   data.userEmail || user?.email || '',
          contact: data.userPhone || (user?.phone ? `+91${user.phone}` : ''),
        },
        theme: { color: '#b8924a' },

        handler: async (response) => {
          // Step 3: Verify payment + create DB order
          try {
            const verifyRes = await paymentAPI.verifyRazorpayPayment({
              razorpayOrderId:   response.razorpay_order_id,
              razorpayPaymentId: response.razorpay_payment_id,
              razorpaySignature: response.razorpay_signature,
              shippingAddress:   getShippingAddress()
            });
            clearCart();
            toast.success(`🎉 Order ${verifyRes.data.order.orderId} placed successfully!`);
            navigate('/orders');
          } catch (verifyErr) {
            toast.error(verifyErr.response?.data?.message || 'Payment verification failed. Please contact support.');
          } finally {
            setProcessing(false);
          }
        },

        modal: {
          ondismiss: () => {
            toast('Payment cancelled.', { icon: 'ℹ️' });
            setProcessing(false);
          }
        }
      };

      const rzp = new window.Razorpay(options);
      rzp.on('payment.failed', (response) => {
        toast.error(`Payment failed: ${response.error.description || 'Please try again.'}`);
        setProcessing(false);
      });
      rzp.open();

    } catch (e) {
      toast.error(e.response?.data?.message || 'Could not start payment. Please try again.');
      setProcessing(false);
    }
  };

  const handleCodCheckout = async () => {
    if (!validateAddress()) return;
    setProcessing(true);
    try {
      const { data } = await paymentAPI.placeCodOrder({ shippingAddress: getShippingAddress(), couponCode: couponCode || undefined });
      clearCart();
      toast.success(`Order ${data.order.orderId} placed! 🎉 Pay ₹${data.order.grandTotal?.toLocaleString('en-IN')} on delivery.`);
      navigate('/orders');
    } catch (e) {
      toast.error(e.response?.data?.message || 'Could not place order. Please try again.');
      setProcessing(false);
    }
  };

  const applyCoupon = async () => {
    if (!couponInput.trim()) return;
    setCouponLoading(true); setCouponError('');
    try {
      const { data } = await couponAPI.validate({ code: couponInput.trim(), subtotal: cart.subtotal });
      setCouponData(data);
      setCouponCode(couponInput.trim().toUpperCase());
      toast.success(data.message);
    } catch (e) {
      setCouponError(e.response?.data?.message || 'Invalid coupon');
      setCouponData(null); setCouponCode('');
    } finally { setCouponLoading(false); }
  };

  const removeCoupon = () => {
    setCouponCode(''); setCouponInput(''); setCouponData(null); setCouponError('');
  };

  const handleCheckout = () =>
    payMethod === 'cod' ? handleCodCheckout() : handleRazorpayCheckout();

  if (cart.items.length === 0) return (
    <div className="container section">
      <EmptyState
        icon="🛍"
        title="Your cart is empty"
        message="Browse our collection and add some outfits!"
        action={() => navigate('/browse')}
        actionLabel="Browse Collection"
      />
    </div>
  );

  const STEPS = [
    { key: 'cart',    label: 'Cart' },
    { key: 'address', label: 'Delivery' },
    { key: 'payment', label: 'Payment' },
  ];
  const stepIdx = STEPS.findIndex(s => s.key === step);

  return (
    <div className="container section fade-in" style={{ padding: 'clamp(24px, 4vw, 72px) clamp(14px, 4vw, 28px)' }}>
      <div className="page-header" style={{ marginBottom: 20 }}>
        <p className="eyebrow">Shopping Bag</p>
        <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 'clamp(28px, 5vw, 40px)', fontStyle: 'italic' }}>
          Your Cart
        </h1>
      </div>

      {/* Verification banner */}
      {!canCheckout && (
        <div style={s.verifyBanner}>
          <span style={{ fontSize: 22, flexShrink: 0 }}>🔒</span>
          <div style={{ flex: 1, minWidth: 0 }}>
            {!isEmailVerified ? (
              <><div style={s.bannerTitle}>Email Verification Required</div>
                <div style={s.bannerText}>Please verify your email before placing an order.</div></>
            ) : overLimit ? (
              <><div style={s.bannerTitle}>Order Limit: ₹{orderLimit.toLocaleString('en-IN')} (Your current level: {trustLevel.name})</div>
                <div style={s.bannerText}>
                  {nextLevel
                    ? `Earn ${nextLevel.min - trustPoints} more Warba Score points to reach ${nextLevel.name} and unlock orders up to ₹${nextLevel.limit === Infinity ? 'unlimited' : nextLevel.limit.toLocaleString('en-IN')}.`
                    : 'Verify your college email to place unlimited orders.'}
                </div></>
            ) : null}
          </div>

        </div>
      )}

      {/* Step indicator */}
      <div style={s.stepBar}>
        {STEPS.map((st, i) => (
          <button
            key={st.key}
            onClick={() => i < stepIdx && setStep(st.key)}
            style={{
              ...s.stepItem,
              borderBottom: i <= stepIdx ? '2px solid var(--gold)' : '2px solid transparent',
              color: i <= stepIdx ? 'var(--gold)' : 'var(--muted)',
              cursor: i < stepIdx ? 'pointer' : 'default',
              flex: 1, background: 'none', border: 'none',
              borderBottom: i <= stepIdx ? '2px solid var(--gold)' : '2px solid transparent',
            }}
          >
            <span style={s.stepNum(i <= stepIdx)}>{i + 1}</span>
            <span style={s.stepLabel}>{st.label}</span>
          </button>
        ))}
      </div>

      {/* ── Two-column layout on desktop, stacked on mobile ── */}
      <div style={s.layout} className="cart-layout">
        {/* Main content */}
        <div style={{ minWidth: 0 }}>
          {/* STEP 1: CART ITEMS */}
          {step === 'cart' && (
            <>
              {cart.items.map(item => (
                <CartItem
                  key={item._id}
                  item={item}
                  onRemove={() => removeFromCart(item._id)}
                  onUpdateQty={(qty) => updateCartItem(item._id, { quantity: qty })}
                />
              ))}
              {/* Coupon code — show here so discount is visible before checkout */}
              <div style={{ border: '1px solid var(--border)', background: 'white', padding: '14px 16px', marginTop: 20 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                  <span style={{ fontSize: 14 }}>🏷️</span>
                  <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--ink)' }}>Have a Coupon?</span>
                </div>
                {couponData ? (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f0faf0', border: '1px solid #c8e6c9', padding: '10px 14px' }}>
                    <div>
                      <span style={{ fontFamily: 'monospace', fontWeight: 700, fontSize: 13, color: '#1b5e20', letterSpacing: '0.06em' }}>{couponCode}</span>
                      <span style={{ fontSize: 12, color: '#2d6a2d', marginLeft: 10 }}>— ₹{couponData.discount.toLocaleString('en-IN')} off applied ✓</span>
                    </div>
                    <button onClick={removeCoupon} style={{ fontSize: 10, fontWeight: 700, color: '#b71c1c', background: 'none', border: 'none', cursor: 'pointer', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Remove</button>
                  </div>
                ) : (
                  <div>
                    <div className="coupon-input-row" style={{ display: 'flex', gap: 8 }}>
                      <input
                        className="input"
                        style={{ flex: 1, textTransform: 'uppercase', letterSpacing: '0.06em', fontSize: 13 }}
                        placeholder="Enter coupon code"
                        value={couponInput}
                        onChange={e => { setCouponInput(e.target.value.toUpperCase()); setCouponError(''); }}
                        onKeyDown={e => e.key === 'Enter' && applyCoupon()}
                      />
                      <button onClick={applyCoupon} disabled={couponLoading || !couponInput.trim()}
                        style={{ padding: '0 18px', fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', background: 'var(--ink)', color: 'var(--gold)', border: 'none', cursor: couponLoading ? 'wait' : 'pointer', opacity: !couponInput.trim() ? 0.5 : 1 }}>
                        {couponLoading ? '...' : 'Apply'}
                      </button>
                    </div>
                    {couponError && <div style={{ fontSize: 11, color: '#c62828', marginTop: 6 }}>{couponError}</div>}
                  </div>
                )}
              </div>

              <button
                className="btn btn-primary w-full"
                style={{ marginTop: 16 }}
                onClick={() => setStep('address')}
                disabled={!canCheckout}
              >
                {canCheckout ? 'Continue to Delivery →' : '🔒 Verify Identity to Continue'}
              </button>
            </>
          )}

          {/* STEP 2: ADDRESS */}
          {step === 'address' && (
            <SmartAddressStep
              address={address}
              setAddress={setAddress}
              user={user}
              onBack={() => setStep('cart')}
              onContinue={() => {
                if (!validateAddress()) return;
                if (deliveryType === 'campus') { setStep('payment'); return; }
                setShowSavePrompt(true);
              }}
              showSavePrompt={showSavePrompt}
              setShowSavePrompt={setShowSavePrompt}
              onProceedToPayment={() => setStep('payment')}
              deliveryType={deliveryType}
              setDeliveryType={setDeliveryType}
              campus={campus}
              setCampus={setCampus}
              COLLEGES={COLLEGES}
              NIT_HOSTELS={NIT_HOSTELS}
            />
          )}

          {/* STEP 3: PAYMENT */}
          {step === 'payment' && (
            <div>
              {/* Security deposit notice */}
              <div style={{ background: '#f0f7f0', border: '1px solid #c8e6c9', padding: '11px 14px', marginBottom: 14, display: 'flex', gap: 10, alignItems: 'center' }}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="2" style={{ flexShrink: 0 }}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                <div style={{ fontSize: 12, color: '#1b5e20' }}>
                  <strong>₹{cart.totalDeposit?.toLocaleString('en-IN')} security deposit included</strong> — 100% refundable after safe return.
                </div>
              </div>

              {/* Amazon-style two-column payment panel */}
              <div className="payment-panel" style={{ border: '1px solid #ddd', background: '#fff', display: 'flex', minHeight: 320 }}>

                {/* LEFT — vertical method list */}
                <div className="payment-panel-left" style={{ width: 200, flexShrink: 0, borderRight: '1px solid #e8e8e8' }}>
                  <div style={{ padding: '12px 14px', background: '#f7f7f7', borderBottom: '1px solid #e8e8e8' }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: '#555', letterSpacing: '0.08em', textTransform: 'uppercase' }}>Payment Method</div>
                  </div>
                  {[
                    { key: 'upi',        label: 'UPI',           sub: 'GPay, PhonePe, Paytm' },
                    { key: 'card',       label: 'Credit / Debit Card', sub: 'Visa, Mastercard, Rupay' },
                    { key: 'netbanking', label: 'Net Banking',   sub: 'All major banks' },
                    { key: 'wallet',     label: 'Wallets',       sub: 'Paytm, Mobikwik & more' },
                    { key: 'cod',        label: 'Cash on Delivery', sub: codEnabled ? 'Pay at doorstep' : 'Unavailable', disabled: !codEnabled },
                  ].map(method => (
                    <div key={method.key}
                      onClick={() => !method.disabled && setPayMethod(method.key)}
                      className={`payment-method-item${payMethod === method.key ? ' payment-method-item-active' : ''}`}
                      style={{
                        padding: '13px 14px',
                        borderBottom: '1px solid #f0f0f0',
                        cursor: method.disabled ? 'not-allowed' : 'pointer',
                        background: payMethod === method.key ? '#fffbf2' : '#fff',
                        borderLeft: payMethod === method.key ? '3px solid #e8a838' : '3px solid transparent',
                        opacity: method.disabled ? 0.45 : 1,
                        transition: 'all 0.15s',
                      }}>
                      <div style={{ fontSize: 12, fontWeight: payMethod === method.key ? 700 : 500, color: payMethod === method.key ? '#b8860b' : '#111' }}>
                        {method.label}
                      </div>
                      <div style={{ fontSize: 10, color: '#999', marginTop: 2 }}>{method.sub}</div>
                    </div>
                  ))}
                </div>

                {/* RIGHT — detail panel for selected method */}
                <div className="payment-panel-right" style={{ flex: 1, padding: '18px 20px' }}>

                  {/* UPI */}
                  {payMethod === 'upi' && (
                    <PayDetail
                      title="Pay via UPI"
                      desc="Enter your UPI ID or scan QR code at checkout. Instant payment, no extra charges."
                      items={['Google Pay', 'PhonePe', 'Paytm UPI', 'BHIM', 'Any UPI app']}
                      note="You will be redirected to Razorpay to complete payment securely."
                    />
                  )}

                  {/* Card */}
                  {payMethod === 'card' && (
                    <PayDetail
                      title="Credit / Debit Card"
                      desc="Pay securely using your card. All major cards accepted."
                      items={['Visa', 'Mastercard', 'Rupay', 'American Express', 'Maestro']}
                      note="Card details are entered on Razorpay's secure page — we never store your card info."
                    />
                  )}

                  {/* Net Banking */}
                  {payMethod === 'netbanking' && (
                    <PayDetail
                      title="Net Banking"
                      desc="Pay directly from your bank account using internet banking."
                      items={['SBI', 'HDFC Bank', 'ICICI Bank', 'Axis Bank', 'Kotak', '50+ more banks']}
                      note="You will be redirected to your bank's secure login page."
                    />
                  )}

                  {/* Wallet */}
                  {payMethod === 'wallet' && (
                    <PayDetail
                      title="Mobile Wallets"
                      desc="Pay using your digital wallet balance."
                      items={['Paytm Wallet', 'Mobikwik', 'Freecharge', 'Airtel Money', 'JioMoney']}
                      note="Wallet must have sufficient balance to complete the payment."
                    />
                  )}

                  {/* COD */}
                  {payMethod === 'cod' && (
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 700, color: '#111', marginBottom: 8 }}>Cash on Delivery</div>
                      <div style={{ fontSize: 12, color: '#555', lineHeight: 1.8, marginBottom: 14 }}>
                        Pay in cash when your order arrives at your door. No online payment required.
                      </div>
                      <div style={{ background: '#fafafa', border: '1px solid #ebebeb', padding: '12px 14px', fontSize: 12, color: '#444', lineHeight: 1.9 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', paddingBottom: 6, marginBottom: 6 }}>
                          <span>Rental amount</span>
                          <span>₹{cart.subtotal?.toLocaleString('en-IN')}</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', paddingBottom: 6, marginBottom: 6 }}>
                          <span>Refundable deposit</span>
                          <span>₹{cart.totalDeposit?.toLocaleString('en-IN')}</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700, color: '#111' }}>
                          <span>Total to pay in cash</span>
                          <span>₹{cart.grandTotal?.toLocaleString('en-IN')}</span>
                        </div>
                      </div>
                      <div style={{ fontSize: 11, color: '#aaa', marginTop: 10 }}>
                        Deposit refunded within 3–5 days after safe return and inspection.
                      </div>
                    </div>
                  )}

                  {/* SSL note at bottom */}
                  <div style={{ marginTop: 'auto', paddingTop: 16, borderTop: '1px solid #f0f0f0', marginTop: 20, display: 'flex', alignItems: 'center', gap: 6 }}>
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                    <span style={{ fontSize: 11, color: '#bbb' }}>
                      {payMethod === 'cod' ? 'No online payment required for COD orders.' : 'All payments processed securely via Razorpay · 256-bit SSL'}
                    </span>
                  </div>
                </div>
              </div>

              {/* Action buttons */}
              <div style={{ ...s.btnRow, marginTop: 14 }}>
                <button className="btn btn-outline" onClick={() => setStep('address')} disabled={processing}>← Back</button>
                <button
                  className="btn btn-gold btn-lg"
                  style={{ flex: 1 }}
                  onClick={handleCheckout}
                  disabled={processing}
                >
                  {processing ? (
                    <><Spinner size="sm" /> {payMethod === 'cod' ? 'Placing Order...' : 'Opening Payment...'}</>
                  ) : payMethod === 'cod'
                    ? `Place Order — ₹${cart.grandTotal?.toLocaleString('en-IN')}`
                    : `Continue to Pay ₹${cart.grandTotal?.toLocaleString('en-IN')} →`
                  }
                </button>
              </div>
              <p style={{ fontSize: 11, color: '#aaa', textAlign: 'center', marginTop: 10, lineHeight: 1.6 }}>
                By placing your order you agree to Warbadobe Rentals' <a href="/terms" style={{ color: '#888' }}>terms</a> and <a href="/refund-policy" style={{ color: '#888' }}>refund policy</a>.
              </p>
            </div>
          )}
        </div>

        {/* ── Order Summary Sidebar ── */}
        <div style={s.sidebar}>
          {/* Mobile: collapsible summary */}
          <div style={s.summaryToggle} className="hide-desktop cart-summary-mobile-toggle" onClick={() => setSummaryOpen(o => !o)}>
            <span style={{ fontSize: 13, fontWeight: 600 }}>Order Summary</span>
            <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <strong style={{ color: 'var(--gold)' }}>₹{cart.grandTotal?.toLocaleString('en-IN')}</strong>
              <span style={{ fontSize: 12 }}>{summaryOpen ? '▲' : '▼'}</span>
            </span>
          </div>

          <div style={s.summaryBody(summaryOpen)} className="cart-summary-body">
            <div style={s.card}>
              <h3 style={{ ...s.cardTitle, display: 'none' }} className="hide-mobile">Order Summary</h3>
              <h3 style={{ ...s.cardTitle }} className="hide-desktop" hidden={!summaryOpen}>Order Summary</h3>

              {cart.items.map(item => (
                <div key={item._id} style={{ display: 'flex', gap: 10, marginBottom: 12 }}>
                  <div style={{ width: 44, height: 52, flexShrink: 0, background: 'var(--cream)', overflow: 'hidden', border: '1px solid var(--border)' }}>
                    {item.productImage
                      ? <img src={item.productImage} alt={item.productName} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      : <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', fontSize: 16 }}>👗</span>
                    }
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 500, fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.productName}</div>
                    <div style={{ color: 'var(--muted)', fontSize: 10, marginTop: 2 }}>
                      Size {item.size} · {item.rentalDurationLabel}{item.quantity > 1 && ` · ×${item.quantity}`}
                    </div>
                    {item.deliveryDate && (
                      <div style={{ fontSize: 10, color: 'var(--ink)', marginTop: 3, display: 'flex', gap: 6 }}>
                        <span style={{ color: 'var(--gold)', fontWeight: 700 }}>Delivery</span>
                        <span>{(() => { try { return new Date(item.deliveryDate).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }); } catch { return '—'; } })()}</span>
                        {item.returnDate && (
                          <>
                            <span style={{ color: 'var(--border)' }}>·</span>
                            <span style={{ color: 'var(--muted)' }}>Return by {(() => { try { return new Date(item.returnDate).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }); } catch { return '—'; } })()}</span>
                          </>
                        )}
                      </div>
                    )}
                    <div style={{ fontSize: 12, marginTop: 4 }}>
                      ₹{(item.rentalPrice * (item.quantity || 1))?.toLocaleString('en-IN')}
                      <span style={{ color: 'var(--muted)', fontSize: 10 }}> +₹{(item.securityDeposit * (item.quantity || 1))?.toLocaleString('en-IN')} dep.</span>
                    </div>
                  </div>
                </div>
              ))}
              <hr className="divider" />
              <PriceRow label="Rental Subtotal"       amount={cart.subtotal} />
              <PriceRow label="Refundable Deposit"    amount={cart.totalDeposit} />
              {couponData && (
                <PriceRow label={`Coupon (${couponCode})`} amount={-couponData.discount} style={{ color: '#2d6a2d', fontWeight: 700 }} />
              )}
              {deliveryInfo.charge > 0 && (
                <PriceRow label={deliveryInfo.label || 'Delivery'} amount={deliveryInfo.charge} />
              )}
              <hr className="divider" />
              <PriceRow label="Total (incl. deposit)" amount={(cart.grandTotal || 0) - (couponData?.discount || 0) + (deliveryInfo?.charge || 0)} bold gold />
              <p style={{ fontSize: 10, color: 'var(--muted)', marginTop: 8, lineHeight: 1.7 }}>
                Deposit refunded within 3–5 days after return.
              </p>
            </div>

            {/* Verification status */}
            <div style={{ ...s.card, padding: '12px 16px', marginTop: 12 }}>
              <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--muted)', marginBottom: 10 }}>
                Verification Status
              </div>
              <VerifyRow icon="📧" label="Email"    done={isEmailVerified} />
              {!canCheckout && (
                <Link to="/profile" className="btn btn-outline btn-sm w-full" style={{ marginTop: 10 }}>
                  Complete Verification
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Cart Item ─────────────────────────────────────────────────────────────────
function CartItem({ item, onRemove, onUpdateQty }) {
  const [removing,  setRemoving]  = useState(false);
  const [updatingQ, setUpdatingQ] = useState(false);

  const fmtDate = (d) => { try { return format(new Date(d), 'dd MMM yyyy'); } catch { return '—'; } };

  const handleRemove = async () => {
    setRemoving(true);
    try { await onRemove(); }
    catch { toast.error('Could not remove item.'); setRemoving(false); }
  };

  const changeQty = async (delta) => {
    const newQty = (item.quantity || 1) + delta;
    if (newQty < 1) return;
    setUpdatingQ(true);
    try { await onUpdateQty(newQty); }
    catch { toast.error('Could not update quantity.'); }
    finally { setUpdatingQ(false); }
  };

  return (
    <div style={s.cartItem}>
      <div style={s.cartImg}>
        {item.productImage
          ? <img src={item.productImage} alt={item.productName} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          : <span style={{ fontSize: 24 }}>👗</span>
        }
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 17, marginBottom: 6, lineHeight: 1.3 }}>
          {item.productName || 'Product'}
        </div>

        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 8 }}>
          <span className="tag">Size {item.size}</span>
          <span className="tag">{item.rentalDurationLabel}</span>
        </div>

        <div style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.9 }}>
          📅 Delivery: <strong>{fmtDate(item.deliveryDate)}</strong><br />
          📦 Return by: <strong>{fmtDate(item.returnDate)}</strong>
        </div>

        {/* Bottom row: qty + price + remove */}
        <div style={s.cartItemBottom}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: 10, color: 'var(--muted)', letterSpacing: '0.06em' }}>QTY</span>
            <div style={s.qtyWrap}>
              <button style={s.qtyBtn} onClick={() => changeQty(-1)} disabled={updatingQ || (item.quantity || 1) <= 1}>−</button>
              <span style={s.qtyNum}>{updatingQ ? '…' : (item.quantity || 1)}</span>
              <button style={s.qtyBtn} onClick={() => changeQty(1)}  disabled={updatingQ || (item.quantity || 1) >= 10}>+</button>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontWeight: 700, fontSize: 15 }}>₹{(item.rentalPrice * (item.quantity || 1))?.toLocaleString('en-IN')}</div>
              <div style={{ fontSize: 10, color: 'var(--muted)' }}>+₹{(item.securityDeposit * (item.quantity || 1))?.toLocaleString('en-IN')} dep.</div>
            </div>
            <button onClick={handleRemove} disabled={removing} style={s.removeBtn}>
              {removing ? '...' : '✕'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function PayDetail({ title, desc, items, note }) {
  return (
    <div>
      <div style={{ fontSize: 14, fontWeight: 700, color: '#111', marginBottom: 8 }}>{title}</div>
      <div style={{ fontSize: 12, color: '#555', lineHeight: 1.8, marginBottom: 14 }}>{desc}</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {items.map((item, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 0', borderBottom: '1px solid #f5f5f5' }}>
            <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#e8a838', flexShrink: 0 }} />
            <span style={{ fontSize: 12, color: '#333' }}>{item}</span>
          </div>
        ))}
      </div>
      {note && (
        <div style={{ marginTop: 14, fontSize: 11, color: '#888', lineHeight: 1.7, padding: '8px 12px', background: '#fafafa', border: '1px solid #ebebeb' }}>
          {note}
        </div>
      )}
    </div>
  );
}

function PayMethodCard({ active, onClick, icon, title, subtitle, badge }) {
  return (
    <div onClick={onClick} style={{ ...s.payCard, border: `2px solid ${active ? 'var(--gold)' : 'var(--border)'}`, background: active ? 'rgba(184,146,74,0.05)' : 'white' }}>
      <span style={{ fontSize: 26, flexShrink: 0 }}>{icon}</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 600, fontSize: 13, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          {title}
          {badge && <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: '0.1em', color: 'var(--gold)', border: '1px solid var(--gold)', padding: '1px 6px' }}>{badge}</span>}
        </div>
        <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>{subtitle}</div>
      </div>
      <div style={{ width: 18, height: 18, borderRadius: '50%', flexShrink: 0, border: `2px solid ${active ? 'var(--gold)' : 'var(--border)'}`, background: active ? 'var(--gold)' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {active && <div style={{ width: 7, height: 7, borderRadius: '50%', background: 'white' }} />}
      </div>
    </div>
  );
}

function VerifyRow({ icon, label, done, pending }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
      <span style={{ fontSize: 14 }}>{icon}</span>
      <span style={{ fontSize: 12, flex: 1 }}>{label}</span>
      <span style={{ fontSize: 11, fontWeight: 700, color: done ? '#1b5e20' : pending ? '#856404' : '#b71c1c' }}>
        {done ? '✓ Verified' : pending ? '⏳ Pending' : '✗ Required'}
      </span>
    </div>
  );
}

const s = {
  layout:         { display: 'grid', gridTemplateColumns: '1fr clamp(260px, 30%, 340px)', gap: 28, alignItems: 'start' },
  sidebar:        { position: 'sticky', top: 80, display: 'flex', flexDirection: 'column' },
  summaryToggle:  { display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'white', border: '1px solid var(--border)', padding: '12px 16px', cursor: 'pointer', marginBottom: 0 },
  summaryBody:    (open) => ({ display: open ? 'block' : 'none' }),
  card:           { background: 'white', border: '1px solid var(--border)', padding: 20 },
  cardTitle:      { fontFamily: "'Cormorant Garamond', serif", fontSize: 20, marginBottom: 14 },
  cartItem:       { display: 'flex', gap: 14, padding: 16, background: 'white', border: '1px solid var(--border)', marginBottom: 10 },
  cartImg:        { width: 80, height: 96, background: 'var(--cream)', flexShrink: 0, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid var(--border)' },
  cartItemBottom: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 12, flexWrap: 'wrap', gap: 8 },
  qtyWrap:        { display: 'flex', alignItems: 'center', border: '1px solid var(--border)', background: 'var(--cream)' },
  qtyBtn:         { width: 32, height: 32, background: 'none', border: 'none', cursor: 'pointer', fontSize: 16, fontWeight: 700, color: 'var(--ink)', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 32 },
  qtyNum:         { width: 32, textAlign: 'center', fontSize: 13, fontWeight: 600, borderLeft: '1px solid var(--border)', borderRight: '1px solid var(--border)', lineHeight: '32px' },
  removeBtn:      { background: 'none', border: '1px solid #f5c6cb', color: '#c0392b', cursor: 'pointer', fontSize: 12, padding: '6px 12px', transition: 'all 0.15s', minHeight: 36, minWidth: 36, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  verifyBanner:   { display: 'flex', gap: 12, alignItems: 'flex-start', background: '#fff8e1', border: '1px solid #ffc107', padding: '14px 16px', marginBottom: 20, flexWrap: 'wrap' },
  bannerTitle:    { fontWeight: 700, fontSize: 13, color: '#856404' },
  bannerText:     { fontSize: 12, color: '#856404', marginTop: 2 },
  stepBar:        { display: 'flex', marginBottom: 28, borderBottom: '1px solid var(--border)', overflowX: 'auto' },
  stepItem:       { padding: '11px 8px', fontSize: 11, fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: 6, justifyContent: 'center', whiteSpace: 'nowrap', background: 'none' },
  stepNum:        (active) => ({ width: 20, height: 20, borderRadius: '50%', background: active ? 'var(--gold)' : 'var(--border)', color: active ? 'var(--ink)' : 'var(--muted)', fontSize: 10, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }),
  stepLabel:      { fontSize: 11 },
  formGrid2:      { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12 },
  formGrid3:      { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: 12 },
  btnRow:         { display: 'flex', gap: 10, marginTop: 12, flexWrap: 'wrap' },
  depositNotice:  { display: 'flex', gap: 10, alignItems: 'flex-start', background: '#e8f5e9', border: '1px solid #a5d6a7', padding: 12, marginBottom: 18 },
  codNotice:      { display: 'flex', gap: 10, alignItems: 'flex-start', background: '#e3f2fd', border: '1px solid #90caf9', padding: 12, marginBottom: 14 },
  stripeCta:      { background: 'var(--cream)', border: '1px solid var(--border)', padding: '10px 12px', marginBottom: 4 },
  payCard:        { display: 'flex', gap: 12, alignItems: 'center', padding: '14px 16px', cursor: 'pointer', transition: 'all 0.2s' },
  payCardDisabled:{ display: 'flex', gap: 12, alignItems: 'center', padding: '14px 16px', border: '2px solid var(--border)', background: '#fafafa', opacity: 0.55, cursor: 'not-allowed' },
};

// ── Smart Address Step ────────────────────────────────────────────────────────
function SmartAddressStep({ address, setAddress, user, onBack, onContinue, showSavePrompt, setShowSavePrompt, onProceedToPayment, deliveryType, setDeliveryType, campus, setCampus, COLLEGES, NIT_HOSTELS }) {
  const [locating,        setLocating]        = useState(false);
  const [locError,        setLocError]        = useState('');
  const [pincodeLoading,  setPincodeLoading]  = useState(false);
  const [selectedSaved,   setSelectedSaved]   = useState(null); // addrId | 'gps' | null
  const [savedAddresses,  setSavedAddresses]  = useState(user?.savedAddresses || []);
  const [showAddrPicker,  setShowAddrPicker]  = useState(false);
  const [addrLoading,     setAddrLoading]     = useState(false);

  const defaultAddr = savedAddresses.find(a => a.isDefault) || savedAddresses[0];
  const hasSavedAddresses = savedAddresses.length > 0;

  // Always fetch fresh addresses from API — auth context user may be stale from localStorage
  useEffect(() => {
    setAddrLoading(true);
    addressAPI.getAll()
      .then(({ data }) => {
        const addrs = data.addresses || [];
        setSavedAddresses(addrs);
        // Auto-select default if address not yet filled
        if (!address.street) {
          const def = addrs.find(a => a.isDefault) || addrs[0];
          if (def) applyAddr(def);
        }
      })
      .catch(() => {}) // non-fatal — fallback to manual entry
      .finally(() => setAddrLoading(false));
  }, []); // eslint-disable-line

  const applyAddr = (addr) => {
    setAddress(a => ({
      ...a,
      name:    addr.name    || a.name || '',
      phone:   addr.phone   || a.phone || '',
      street:  addr.street  || '',
      city:    addr.city    || '',
      state:   addr.state   || '',
      pincode: addr.pincode || '',
    }));
    setSelectedSaved(addr._id);
    setLocError('');
    setShowAddrPicker(false);
  };

  const useCurrentLocation = () => {
    if (!navigator.geolocation) {
      setLocError('Geolocation is not supported by your browser.');
      return;
    }
    setLocating(true);
    setLocError('');
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        try {
          const { latitude, longitude } = pos.coords;
          // Use OpenStreetMap Nominatim (free, no API key needed)
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json&addressdetails=1`,
            { headers: { 'Accept-Language': 'en' } }
          );
          const data = await res.json();
          const a = data.address || {};

          const street  = [a.road, a.neighbourhood, a.suburb].filter(Boolean).join(', ') || '';
          const city    = a.city || a.town || a.village || a.county || '';
          const state   = a.state || '';
          const pincode = a.postcode || '';

          setAddress(prev => ({
            ...prev,
            street:  street  || prev.street,
            city:    city    || prev.city,
            state:   state   || prev.state,
            pincode: pincode || prev.pincode,
          }));
          setSelectedSaved('gps');
          if (!city) setLocError('Could not detect full address. Please fill remaining fields.');
        } catch {
          setLocError('Could not fetch address. Please enter manually.');
        } finally {
          setLocating(false);
        }
      },
      (err) => {
        setLocating(false);
        if (err.code === 1) setLocError('Location access denied. Please allow location or enter address manually.');
        else setLocError('Could not get location. Please enter address manually.');
      },
      { timeout: 10000, enableHighAccuracy: true }
    );
  };

  // Auto-fill city/state from pincode using postal API
  const handlePincodeChange = async (val) => {
    setAddress(a => ({ ...a, pincode: val }));
    if (val.length === 6 && /^\d{6}$/.test(val)) {
      setPincodeLoading(true);
      try {
        const res  = await fetch(`https://api.postalpincode.in/pincode/${val}`);
        const data = await res.json();
        if (data[0]?.Status === 'Success') {
          const post = data[0].PostOffice?.[0];
          if (post) {
            setAddress(a => ({
              ...a,
              city:  post.District || a.city,
              state: post.State    || a.state,
            }));
          }
        }
      } catch {}
      finally { setPincodeLoading(false); }
    }
  };

  return (
    <div style={s.card}>
      <h3 style={s.cardTitle}>Delivery Address</h3>

      {/* ── Delivery type toggle ── */}
      <div style={{ display: 'flex', marginBottom: 20, border: '1px solid var(--border)', overflow: 'hidden' }}>
        {[
          { type: 'campus', label: '🎓 Campus Delivery', desc: 'Hostel room delivery' },
          { type: 'home',   label: '🏠 Home Delivery',   desc: 'Standard address' },
        ].map(({ type, label, desc }) => (
          <button key={type} onClick={() => setDeliveryType(type)} style={{
            flex: 1, padding: '12px 16px', border: 'none', cursor: 'pointer',
            background: deliveryType === type ? 'var(--ink)' : 'white',
            color: deliveryType === type ? 'var(--cream)' : 'var(--muted)',
            borderRight: type === 'campus' ? '1px solid var(--border)' : 'none',
            transition: 'all 0.2s',
          }}>
            <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 2 }}>{label}</div>
            <div style={{ fontSize: 10, opacity: 0.65 }}>{desc}</div>
          </button>
        ))}
      </div>

      {/* ── Campus delivery form ── */}
      {deliveryType === 'campus' && (
        <div>
          <div style={{ padding: '10px 14px', background: 'rgba(184,146,74,0.08)', border: '1px solid rgba(184,146,74,0.25)', marginBottom: 20, fontSize: 12, color: 'var(--ink)', lineHeight: 1.7 }}>
            We deliver directly to your hostel room. Select your college and hostel below.
          </div>
          <div style={s.formGrid2}>
            {[
              { key: 'name',  label: 'Your Name *',    placeholder: 'Full name',  type: 'text' },
              { key: 'phone', label: 'Phone Number *', placeholder: '9876543210', type: 'tel' },
            ].map(f => (
              <div key={f.key} className="form-group">
                <label className="form-label">{f.label}</label>
                <input className="input" type={f.type} value={campus[f.key]} placeholder={f.placeholder}
                  onChange={e => setCampus(p => ({ ...p, [f.key]: e.target.value }))} />
              </div>
            ))}
          </div>
          <div className="form-group">
            <label className="form-label">College *</label>
            <select className="input" value={campus.college}
              onChange={e => setCampus(p => ({ ...p, college: e.target.value, hostel: '' }))}>
              {COLLEGES.map(col => <option key={col} value={col}>{col}</option>)}
            </select>
          </div>
          <div style={s.formGrid2}>
            <div className="form-group">
              <label className="form-label">Hostel *</label>
              <select className="input" value={campus.hostel}
                onChange={e => setCampus(p => ({ ...p, hostel: e.target.value }))}>
                <option value="">Select hostel</option>
                {(campus.college === 'NIT Jalandhar' ? NIT_HOSTELS : ['Block A','Block B','Block C','Other']).map(h => (
                  <option key={h} value={h}>{h}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Room Number *</label>
              <input className="input" placeholder="e.g. 204" value={campus.roomNo}
                onChange={e => setCampus(p => ({ ...p, roomNo: e.target.value }))} />
            </div>
          </div>
          {campus.hostel && campus.roomNo && (
            <div style={{ padding: '10px 14px', background: 'var(--cream)', border: '1px solid var(--border)', fontSize: 11, color: 'var(--muted)', marginBottom: 16, lineHeight: 1.6 }}>
              📦 Delivering to: <strong style={{ color: 'var(--ink)' }}>
                {campus.hostel} Hostel, Room {campus.roomNo} — {campus.college}
              </strong>
            </div>
          )}
          <div style={s.btnRow}>
            <button className="btn btn-outline" onClick={onBack}>← Back</button>
            <button className="btn btn-primary" style={{ flex: 1 }} onClick={onContinue}>
              Continue to Payment →
            </button>
          </div>
        </div>
      )}

      {/* ── Home delivery ── */}
      {deliveryType === 'home' && <>

      {/* ── Address options row ── */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap' }}>

        {/* GPS button */}
        <button
          onClick={useCurrentLocation}
          disabled={locating}
          style={{
            display: 'flex', alignItems: 'center', gap: 8,
            padding: '10px 16px', border: `2px solid ${selectedSaved === 'gps' ? 'var(--gold)' : 'var(--border)'}`,
            background: selectedSaved === 'gps' ? 'rgba(184,146,74,0.06)' : 'white',
            cursor: locating ? 'wait' : 'pointer', fontSize: 13, fontWeight: 600,
            color: selectedSaved === 'gps' ? 'var(--gold)' : 'var(--ink)',
            transition: 'all 0.15s', flex: 1, minWidth: 160, justifyContent: 'center',
          }}
        >
          <span style={{ fontSize: 18 }}>📍</span>
          {locating ? 'Detecting...' : 'Use My Location'}
        </button>

        {/* Saved addresses button */}
        {(hasSavedAddresses || addrLoading) && (
          <button
            onClick={() => !addrLoading && setShowAddrPicker(p => !p)}
            style={{
              display: 'flex', alignItems: 'center', gap: 8,
              padding: '10px 16px', border: `2px solid ${savedAddresses.some(a => a._id === selectedSaved) ? 'var(--gold)' : 'var(--border)'}`,
              background: savedAddresses.some(a => a._id === selectedSaved) ? 'rgba(184,146,74,0.06)' : 'white',
              cursor: 'pointer', fontSize: 13, fontWeight: 600,
              color: savedAddresses.some(a => a._id === selectedSaved) ? 'var(--gold)' : 'var(--ink)',
              transition: 'all 0.15s', flex: 1, minWidth: 160, justifyContent: 'center',
            }}
          >
            <span style={{ fontSize: 18 }}>🏠</span>
            {addrLoading ? 'Loading addresses…' : savedAddresses.length === 1 ? 'Saved Address' : `Saved Addresses (${savedAddresses.length})`}
            {!addrLoading && <span style={{ fontSize: 10, marginLeft: 4 }}>{showAddrPicker ? '▲' : '▼'}</span>}
          </button>
        )}
      </div>

      {/* Saved address picker dropdown */}
      {showAddrPicker && hasSavedAddresses && (
        <div style={{ border: '1px solid var(--border)', marginBottom: 16, overflow: 'hidden' }}>
          {savedAddresses.map(addr => (
            <div key={addr._id} onClick={() => applyAddr(addr)}
              style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid var(--border)',
                background: selectedSaved === addr._id ? 'rgba(184,146,74,0.06)' : 'white',
                transition: 'background 0.15s' }}
              onMouseEnter={e => { if (selectedSaved !== addr._id) e.currentTarget.style.background = '#fafafa'; }}
              onMouseLeave={e => { if (selectedSaved !== addr._id) e.currentTarget.style.background = 'white'; }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: 2 }}>
                    <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--ink)' }}>{addr.label || 'Address'}</span>
                    {addr.isDefault && <span style={{ fontSize: 9, color: 'var(--gold)', fontWeight: 700 }}>DEFAULT</span>}
                  </div>
                  {addr.name && <div style={{ fontSize: 13, fontWeight: 600 }}>{addr.name}</div>}
                  <div style={{ fontSize: 12, color: '#555' }}>{addr.street}, {addr.city} — {addr.pincode}</div>
                  {addr.phone && <div style={{ fontSize: 11, color: 'var(--muted)' }}>📞 {addr.phone}</div>}
                </div>
                {selectedSaved === addr._id && <span style={{ color: 'var(--gold)', fontWeight: 700, fontSize: 16 }}>✓</span>}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Selected saved address preview (when picker is closed) */}
      {!showAddrPicker && savedAddresses.some(a => a._id === selectedSaved) && (() => {
        const sel = savedAddresses.find(a => a._id === selectedSaved);
        return (
          <div style={{ background: 'rgba(184,146,74,0.06)', border: '1px solid rgba(184,146,74,0.3)', padding: '10px 14px', marginBottom: 16, fontSize: 13, color: '#555', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            <div>
              <div style={{ fontWeight: 600, marginBottom: 2 }}>{sel.name || address.name}</div>
              <div>{sel.street}, {sel.city}</div>
              {sel.phone && <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>📞 {sel.phone}</div>}
            </div>
            <span style={{ fontSize: 11, color: 'var(--gold)', fontWeight: 700 }}>✓ Selected</span>
          </div>
        );
      })()}

      {/* GPS success notice */}
      {selectedSaved === 'gps' && !locating && (
        <div style={{ background: '#e8f5e9', border: '1px solid #a5d6a7', padding: '8px 14px', marginBottom: 16, fontSize: 12, color: '#1b5e20' }}>
          📍 Location detected — please verify the fields below and fill in your house/flat number.
        </div>
      )}

      {/* Location error */}
      {locError && (
        <div style={{ background: '#fff8e1', border: '1px solid #ffc107', padding: '8px 14px', marginBottom: 16, fontSize: 12, color: '#856404' }}>
          ⚠️ {locError}
        </div>
      )}

      <div style={{ borderTop: '1px solid var(--border)', paddingTop: 16, marginBottom: 4 }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--muted)', marginBottom: 14 }}>
          {selectedSaved ? 'Confirm Details' : 'Enter Address Manually'}
        </div>
      </div>

      {/* Name + Phone */}
      <div style={s.formGrid2}>
        {[
          { key: 'name',  label: 'Full Name *',    placeholder: 'Recipient name' },
          { key: 'phone', label: 'Phone Number *',  placeholder: '9876543210' },
        ].map(f => (
          <div key={f.key} className="form-group">
            <label className="form-label">{f.label}</label>
            <input className="input" value={address[f.key]} placeholder={f.placeholder}
              onChange={e => setAddress(a => ({ ...a, [f.key]: e.target.value }))} />
          </div>
        ))}
      </div>

      {/* Street */}
      <div className="form-group">
        <label className="form-label">House / Flat / Building *</label>
        <input className="input" value={address.street} placeholder="e.g. 42B, Sunrise Apartments, MG Road"
          onChange={e => setAddress(a => ({ ...a, street: e.target.value }))} />
      </div>

      {/* Pincode + City + State */}
      <div style={s.formGrid3}>
        <div className="form-group">
          <label className="form-label">Pincode *</label>
          <div style={{ position: 'relative' }}>
            <input className="input" value={address.pincode} placeholder="141001" maxLength={6}
              onChange={e => handlePincodeChange(e.target.value)} />
            {pincodeLoading && (
              <span style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', fontSize: 11, color: 'var(--gold)' }}>...</span>
            )}
          </div>
        </div>
        <div className="form-group">
          <label className="form-label">City *</label>
          <input className="input" value={address.city} placeholder="Ludhiana"
            onChange={e => setAddress(a => ({ ...a, city: e.target.value }))} />
        </div>
        <div className="form-group">
          <label className="form-label">State *</label>
          <input className="input" value={address.state} placeholder="Punjab"
            onChange={e => setAddress(a => ({ ...a, state: e.target.value }))} />
        </div>
      </div>

      <div style={s.btnRow}>
        <button className="btn btn-outline" onClick={onBack}>← Back</button>
        <button className="btn btn-primary" style={{ flex: 1 }} onClick={onContinue}>
          Continue to Payment →
        </button>
      </div>

      </> /* end home delivery */}

      {/* ── Save Address Prompt Modal ── */}
      {showSavePrompt && deliveryType === 'home' && (
        <SaveAddressPrompt
          address={address}
          isNewAddress={!savedAddresses.some(a => a._id === selectedSaved)}
          onSave={async (label, name, phone) => {
            try {
              await addressAPI.add({
                label,
                name:    name    || address.name    || '',
                phone:   phone   || address.phone   || '',
                street:  address.street,
                city:    address.city,
                state:   address.state,
                pincode: address.pincode,
                isDefault: savedAddresses.length === 0,
              });
              toast.success('Address saved to your profile!');
            } catch { /* non-fatal — proceed anyway */ }
            setShowSavePrompt(false);
            onProceedToPayment();
          }}
          onSkip={() => { setShowSavePrompt(false); onProceedToPayment(); }}
        />
      )}
    </div>
  );
}

// ── Save Address Prompt (modal overlay) ───────────────────────────────────────
function SaveAddressPrompt({ address, isNewAddress, onSave, onSkip }) {
  const [label,   setLabel]   = useState('Home');
  const [name,    setName]    = useState(address.name  || '');
  const [phone,   setPhone]   = useState(address.phone || '');
  const [saving,  setSaving]  = useState(false);
  const LABELS = ['Home', 'Work', 'Other'];

  if (!isNewAddress) {
    // Already a saved address selected — go straight through
    setTimeout(onSkip, 0);
    return null;
  }

  const handleSave = async () => {
    if (phone && !/^[6-9]\d{9}$/.test(phone)) { toast.error('Enter a valid 10-digit mobile number.'); return; }
    setSaving(true);
    await onSave(label, name, phone);
    setSaving(false);
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ background: 'white', width: '100%', maxWidth: 440, padding: 24, boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
        {/* Header */}
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: '0.22em', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: 6 }}>Quick Save</div>
          <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, fontWeight: 300, color: 'var(--ink)', marginBottom: 4 }}>Save this address?</div>
          <div style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.6 }}>
            <strong>{address.street}</strong><br />
            {address.city}{address.state ? `, ${address.state}` : ''} — {address.pincode}
          </div>
        </div>

        {/* Label selector */}
        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--muted)', marginBottom: 8 }}>Label</div>
          <div style={{ display: 'flex', gap: 8 }}>
            {LABELS.map(l => (
              <button key={l} onClick={() => setLabel(l)}
                style={{ padding: '6px 16px', fontSize: 12, border: '1px solid', cursor: 'pointer', transition: 'all 0.15s',
                  borderColor: label === l ? 'var(--gold)' : 'var(--border)',
                  background:  label === l ? 'rgba(184,146,74,0.08)' : 'white',
                  color:       label === l ? 'var(--gold)' : 'var(--muted)',
                  fontWeight:  label === l ? 700 : 400 }}>
                {l}
              </button>
            ))}
          </div>
        </div>

        {/* Name */}
        <div className="form-group" style={{ marginBottom: 12 }}>
          <label className="form-label">Recipient Name</label>
          <input className="input" value={name} placeholder="e.g. Riya Sharma"
            onChange={e => setName(e.target.value)} />
        </div>

        {/* Phone */}
        <div className="form-group" style={{ marginBottom: 20 }}>
          <label className="form-label">Phone Number</label>
          <input className="input" inputMode="tel" value={phone} placeholder="10-digit number"
            onChange={e => setPhone(e.target.value.replace(/\D/g,'').slice(0,10))} />
        </div>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onSkip}
            style={{ flex: 1, padding: '11px', fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', border: '1px solid var(--border)', background: 'none', color: 'var(--muted)', cursor: 'pointer' }}>
            Skip
          </button>
          <button onClick={handleSave} disabled={saving}
            style={{ flex: 2, padding: '11px', fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', background: 'var(--ink)', color: 'var(--cream)', border: 'none', cursor: saving ? 'wait' : 'pointer' }}>
            {saving ? 'Saving…' : 'Save & Continue →'}
          </button>
        </div>
      </div>
    </div>
  );
}